<template>
	<el-dialog :title="nameTitle" :visible.sync="dialogVisible" width="1000px" top="5vh" :before-close="handleClose"
		custom-class="watch-acc-dialog" append-to-body>

		<!-- 对话框内容 -->
		<div class="dialog-content">
			<!-- 基本信息区域 -->
			<div class="section">
				<div class="section-header">
					<span class="section-title">基本信息</span>
				</div>

				<!-- 员工信息表格 -->
				<div class="table-section">
					<div class="table-title">员工信息</div>
					<table class="info-table">
						<tbody>
							<tr>
								<td class="label required-field" data-field="fullName" 
								    :class="{ 'error-row': validationErrors.fullName }">姓名：</td>
								<td class="value">
									<el-input v-model="employeeData.fullName" placeholder="请输入姓名" :class="{ 'error-input': validationErrors.fullName }" size="mini"></el-input>
								</td>
								<td class="label">工号：</td>
								<td class="value">{{ employeeData.userCode || nextUserCode }}</td>
								<td class="label">性别：</td>
								<td class="value">
									<el-select v-model="employeeData.sex" placeholder="请先选择性别" size="mini"
										:disabled="true" class="disabled-select">
										<el-option label="男" value="1"></el-option>
										<el-option label="女" value="2"></el-option>
									</el-select>
									<!--  <el-tooltip 
					v-if="!employeeData.idNumber" 
					content="请输入身份证号后自动判断性别" 
					placement="top">
					<i class="el-icon-info" style="color: #909399; margin-left: 5px;"></i>
				  </el-tooltip> -->
								</td>
								<!-- 根据clinicId条件显示不同内容 -->
								<td class="label">机构：</td>
								<td class="value">
									<el-select v-if="actualClinicId == 0" v-model="employeeData.organization"
										placeholder="请选择机构" size="mini" @change="handleOrganizationChange">
										<el-option v-for="item in clincOptions" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
									<span v-else>{{ currentClinicName }}</span>
								</td>

							<tr>
								<td class="label">国籍：</td>
								<td class="value">
									<el-select v-model="employeeData.nationality" placeholder="请选择国籍" size="mini"
										filterable>
										<el-option v-for="item in nationality" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</td>
								<td class="label">证件类型：</td>
								<td class="value">
									<el-select v-model="employeeData.idType" placeholder="请选择国籍" size="mini" filterable
									:disabled="isEditMode">
										<el-option v-for="item in idType" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</td>
								<td class="label required-field" data-field="idNumber" 
								    :class="{ 'error-row': validationErrors.idNumber }">身份证：</td>
								<td class="value" colspan="3">
									<el-input v-model="employeeData.idNumber" placeholder="请输入身份证号" size="mini"
										:class="{ 'error-input': validationErrors.idNumber }" @blur="handleIdNumberBlur"
										@input="validationErrors.idNumber = false">
									</el-input>
								</td>

							</tr>
							<tr data-field="contactNumber" :class="{ 'error-row': validationErrors.contactNumber }">
								<!-- 联系电话字段 -->
								<td class="label required-field" data-field="contactNumber"  
								    :class="{ 'error-row': validationErrors.contactNumber }">电话：</td>
								<td class="value">
									<el-input v-model="employeeData.contactNumber" placeholder="请输入电话号码" size="mini"
										:class="{ 'error-input': validationErrors.contactNumber }" :disabled="isEditMode"
										@input="validationErrors.contactNumber = false">
									</el-input>
								</td>
								<td class="label">出生年月：</td>
								<td class="value">
									<el-date-picker v-model="employeeData.birthDate" type="date" placeholder="选择日期"
										size="mini" value-format="yyyy-MM-dd" :picker-options="birthdayPickerOptions">
									</el-date-picker>
								</td>
								<td class="label">农历生日：</td>
								<td class="value">
									<el-input v-model="employeeData.lunarBirthDate" placeholder="自动计算" size="mini"
										:disabled="true"></el-input>
								</td>
								<td class="label">婚姻状况：</td>
								<td class="value">
									<el-select v-model="employeeData.maritalStatus" placeholder="请选择婚姻状况" size="mini">
										<el-option v-for="item in marryiedOptions" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</td>

							</tr>
							<tr>
								<td class="label">政治面貌：</td>
								<td class="value">
									<el-select v-model="employeeData.politicalStatus" placeholder="请选择政治面貌" size="mini">
										<el-option v-for="item in politicalStatusOptions" :key="item.id"
											:label="item.label" :value="item.id">
										</el-option>
									</el-select>
								</td>
								<td class="label">学历：</td>
								<td class="value">
									<el-select v-model="employeeData.educationalBackground" placeholder="请选择学历" size="mini">
										<el-option v-for="item in xlOptions" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</td>
								<!-- 专业职称字段 -->
								<td class="label required-field" data-field="professionalTitle" 
								    :class="{ 'error-row': validationErrors.professionalTitle }">专业职称：</td>
								<td class="value">
									<el-select v-model="employeeData.professionalTitle" placeholder="请选择专业职称"
										size="mini" filterable
										:class="{ 'error-input': validationErrors.professionalTitle }"
										@change="validationErrors.professionalTitle = false">
										<el-option v-for="item in professionalOptions" :key="item.id"
											:label="item.label" :value="item.id">
										</el-option>
									</el-select>
								</td>
								<td class="label">所学专业：</td>
								<td class="value">
									<el-select v-model="employeeData.major" placeholder="请选择专业" size="mini" filterable>
										<el-option v-for="item in mjOptions" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</td>
							</tr>
							<tr>
								<td class="label">民族：</td>
								<td class="value">
									<el-select v-model="employeeData.minZu" placeholder="请选择国籍" size="mini" filterable>
										<el-option v-for="item in MZOptions" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</td>

								<td class="label">血型：</td>
								<td class="value">
									<el-select v-model="employeeData.bloodType" placeholder="请选择国籍" size="mini"
										filterable>
										<el-option v-for="item in bloodOptions" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</td>
								<td class="label">毕业时间：</td>
								<td class="value">
									<el-date-picker v-model="employeeData.graduationDate" type="date" placeholder="选择日期"
										size="mini" value-format="yyyy-MM-dd">
									</el-date-picker>
								</td>
								<td class="label">参加工作日期：</td>
								<td class="value">
									<el-date-picker v-model="employeeData.dateOfEmp" type="date" placeholder="选择日期"
										size="mini" value-format="yyyy-MM-dd">
									</el-date-picker>
								</td>
							</tr>
							<tr>

								<td class="label">入职时间：</td>
								<td class="value">
									<el-date-picker v-model="employeeData.entryTime" type="date" placeholder="选择日期"
										size="mini" value-format="yyyy-MM-dd">
									</el-date-picker>
								</td>
								<td class="label">社保状态：</td>
								<td class="value">
									<el-select v-model="employeeData.socialSecurityStatus" placeholder="请选择社保状态"
										size="mini" filterable>
										<el-option v-for="item in socialSecurityStatusOptions" :key="item.id"
											:label="item.label" :value="item.id">
										</el-option>
									</el-select>
								</td>
								<td class="label">籍贯：</td>
								<td class="value" colspan="5">
									<el-cascader v-model="nativePlaceValue" :options="nativePlaceOptions"
										:props="cascaderProps" placeholder="请选择籍贯" size="mini" clearable filterable
										style="width: 100%" @change="handleNativePlaceChange">
									</el-cascader>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="section">
				<div class="section-header">
					<span class="section-title">拥有权限</span>
				</div>
				<div class="table-section">
					<div class="table-title">权限信息</div>
					<div class="permissions-container">


						<!-- 第一行：处方权和中药处方权 -->
						<div class="permission-row">
							<!-- 修改：精神权限改为下拉选择框 -->
							<div class="permission-select-item" style="margin: 12px;">
								<span class="permission-label">精神权限：</span>
								<el-select v-model="employeeData.spiritPermission" placeholder="请选择精神权限" size="mini"
									style="width: 120px">
									<el-option label="无" :value="0"></el-option>
									<el-option label="精神一类" :value="1"></el-option>
									<el-option label="精神二类" :value="2"></el-option>
								</el-select>
								<span class="permission-label" style="margin-left: 12px;">抗生素等级：</span>
								<el-select v-model="employeeData.antibioticAuthorization" placeholder="请选择抗生素等级"
									size="mini" style="width: 140px">
									<el-option label="无" :value="0"></el-option>
									<el-option label="一级抗生素" :value="1"></el-option>
									<el-option label="二级抗生素" :value="2"></el-option>
									<el-option label="三级抗生素" :value="3"></el-option>
								</el-select>
							</div>
							<el-checkbox border size="medium" v-model="employeeData.prescriptionRights" :true-label="1"
								:false-label="0">
								处方权
							</el-checkbox>
							<el-checkbox border size="medium" v-model="employeeData.chPrescriptionRights"
								:true-label="1" :false-label="0">
								中药处方权
							</el-checkbox>
						</div>

						<!-- 第二行：其他权限 -->
						<div class="permission-row">
							<el-checkbox border size="medium" v-model="employeeData.anesthesiaAuthorization"
								:true-label="1" :false-label="0">
								麻药权限
							</el-checkbox>
							<el-checkbox border size="medium" v-model="employeeData.surgicalPermission" :true-label="1"
								:false-label="0">
								手术权限
							</el-checkbox>

							<el-checkbox border size="medium" v-model="employeeData.poisonPermission" :true-label="1"
								:false-label="0">
								毒药权限
							</el-checkbox>
							<el-checkbox border size="medium" v-model="employeeData.antiTumorPermission" :true-label="1"
								:false-label="0">
								抗肿瘤药物权限
							</el-checkbox>
						</div>
					</div>
				</div>
			</div>

			<!-- 隶属科室区域 -->
						<div class="section" data-field="deptList" :class="{ 'error-section': validationErrors.deptList }">
							<div class="section-header">
								<span class="section-title">隶属科室</span>
								<el-alert v-if="validationErrors.deptList" :title="validationErrors.deptListMessage" type="error" show-icon
									:closable="false" style="margin-top: 8px;">
								</el-alert>
							</div>
							<div class="table-section">
								<div class="header">
									<div>科室信息</div>
									<div>
										<el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :icon="v.icon" size="mini"
											:disabled="v.disabled || (v.action !== 'add' && !selectedRow) || shouldDisableDeptButtons"
											@click="handleHeaderBtnClick(v, i)">
											{{ v.title }}
										</el-button>
									</div>
								</div>
			
								<el-table :data="tableData" border @row-click="handleRowClick" :row-class-name="tableRowClassName"
									:class="{ 'error-table': validationErrors.deptList }" style="width: 100%">
									<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
										:label="col.name">
										<template slot-scope="scope">
											<span v-if="col.prop === 'mainDep'">
												{{ scope.row.mainDep === 1 ? '是' : '否' }}
												<el-tag v-if="scope.row.mainDep === 1" size="mini" type="success" style="margin-left: 5px;">主要</el-tag>
											</span>
											<span v-else>
												{{ scope.row[col.prop] }}
											</span>
										</template>
									</el-table-column>
									<el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
								</el-table>
								
								<!-- 科室表格校验错误提示 -->
								<div v-if="validationErrors.deptTable" class="error-tip">
									<i class="el-icon-warning"></i>
									{{ validationErrors.deptTableMessage }}
								</div>
							</div>
						</div>

			<!-- 证件信息区域 -->
			<div class="section">
				<div class="table-section">
					<div class="table-title">证件信息</div>
					<table class="info-table">
						<tbody>
							<tr>
								<td class="label">证件名称：</td>
								<td class="value">
									<el-input v-model="employeeData.certificateName" placeholder="请输入证件名称"
										size="mini"></el-input>
								</td>
								<td class="label">执业证号：</td>
								<td class="value">
									<el-input v-model="employeeData.practicingNumber" placeholder="请输入执业证号"
										size="mini"></el-input>
								</td>
								<td class="label">所学专业：</td>
								<td class="value">
									<el-select v-model="employeeData.major" placeholder="请选择专业" size="mini" filterable>
										<el-option v-for="item in mjOptions" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</td>
								<td class="label">资格证书编号：</td>
								<td class="value">
									<el-input v-model="employeeData.qualificationNumber" placeholder="请输入资格证书编号"
										size="mini"></el-input>
								</td>
							</tr>
							<tr>
								<td class="label">职业日期：</td>
								<td class="value">
									<el-date-picker v-model="employeeData.practiceDate" type="date" placeholder="选择日期"
										size="mini" value-format="yyyy-MM-dd">
									</el-date-picker>
								</td>
								<td class="label">生效时间：</td>
								<td class="value">
									<el-date-picker v-model="employeeData.effectiveDate" type="date" placeholder="选择日期"
										size="mini" value-format="yyyy-MM-dd">
									</el-date-picker>
								</td>
								<td class="label">有无期限：</td>
								<td class="value">
									<el-select v-model="employeeData.hasTerm" placeholder="请选择" size="mini">
										<el-option label="有" value="1"></el-option>
										<el-option label="无" value="0"></el-option>
									</el-select>
								</td>
								<td class="label">证书状态：</td>
								<td class="value">
									<el-select v-model="employeeData.certificateStatus" placeholder="请选择状态" size="mini">
										<el-option label="有效" value="valid"></el-option>
										<el-option label="无效" value="invalid"></el-option>
										<el-option label="过期" value="expired"></el-option>
									</el-select>
								</td>
							</tr>
							<tr>
								<td class="label">证书去向：</td>
								<td class="value">
									<el-select v-model="employeeData.certificateDirection" placeholder="请选择去向"
										size="mini">
										<el-option label="转入" value="transfer_in"></el-option>
										<el-option label="转出" value="transfer_out"></el-option>
										<el-option label="存档" value="archived"></el-option>
									</el-select>
								</td>
								<td class="label">存放地点：</td>
								<td class="value">
									<el-input v-model="employeeData.storageLocation" placeholder="请输入存放地点"
										size="mini"></el-input>
								</td>
								<td class="label">医保名称：</td>
								<td class="value">
									<el-input v-model="employeeData.standardCode" placeholder="请输入医保名称"
										size="mini"></el-input>
								</td>

								<td class="label">医保编码：</td>
								<td class="value">
									<el-input v-model="employeeData.standardName" placeholder="请输入医保编码"
										size="mini"></el-input>
								</td>

							</tr>
							<tr>
								<td class="label">备注：</td>
								<td class="value" colspan="7">
									<el-input type="textarea" v-model="employeeData.certificateRemark"
										placeholder="请输入备注信息" size="mini" :rows="2">
									</el-input>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<!-- 其他文件区域 -->
			<div class="section">
				<div class="table-section">
					<div class="table-title">其他文件</div>
					<table class="file-table">
						<thead>
							<tr>
								<th>手工签名</th>
								<th>员工证件照</th>
								<th>资格证电子图片</th>
								<th>执业证电子图片</th>
								<th>上传人</th>
								<th>上传时间</th>
								<th>操作</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<!-- 手工签名单元格 -->
								<td>
									<div class="file-upload-cell">
										<div v-if="employeeData.signatureImage" class="thumbnail-container">
											<!-- 显示签名缩略图 -->
											<img :src="employeeData.signatureImage" alt="手工签名"
												class="signature-thumbnail"
												@click="showImagePreview(employeeData.signatureImage)">

											<div class="thumbnail-actions">
												<!-- 删除改为重新上传 -->
												<el-button type="text" size="mini" @click="reuploadSignature">
													重新上传
												</el-button>
											</div>
										</div>
										<div v-else class="upload-placeholder">
											<span>未上传</span>
											<el-button type="text" icon="el-icon-plus" size="mini"
												@click="openUploadDialog('signature')">
											</el-button>
										</div>
									</div>
								</td>
								<!-- 员工证件照单元格 -->
								<td>
									<div class="file-upload-cell">
										<div v-if="employeeData.workIdPhoto" class="thumbnail-container">

											<div class="thumbnail-actions">
												<!-- <el-upload></el-upload> -->
												<!-- <el-button type="text" size="mini" @click="showImagePreview(employeeData.workIdPhoto)">查看</el-button> -->
												<!-- <el-button type="text" size="mini" @click="removeFile('workPhoto')">删除</el-button> -->
											</div>
										</div>
										<div v-else class="upload-placeholder">
											<span>未上传</span>
											<el-button type="text" icon="el-icon-plus" size="mini"
												@click="openUploadDialog('workPhoto')">
											</el-button>
										</div>
									</div>
								</td>
								<td>
									<div class="file-upload-cell">
										<span v-if="!employeeData.qcElectronicImage">未上传</span>
										<span v-else>{{ getFileName(employeeData.qcElectronicImage) }}</span>
										<el-button type="text" icon="el-icon-plus" size="mini"
											@click="openUploadDialog('qualification')">
										</el-button>
									</div>
								</td>
								<td>
									<div class="file-upload-cell">
										<span v-if="!employeeData.pcElectronicImage">未上传</span>
										<span v-else>{{ getFileName(employeeData.pcElectronicImage) }}</span>
										<el-button type="text" icon="el-icon-plus" size="mini"
											@click="openUploadDialog('practice')">
										</el-button>
									</div>
								</td>
								<td>{{ uploadUser }}</td>
								<td>{{ uploadTime }}</td>
								<td>
									<div class="action-buttons">
										<el-button type="text" size="mini"
											@click="viewFile(employeeData.signatureImage)"
											:disabled="!employeeData.signatureImage">
											查看
										</el-button>
										<el-button type="text" size="mini"
											@click="downloadFile(employeeData.signatureImage)"
											:disabled="!employeeData.signatureImage">
											下载
										</el-button>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<!-- 扫描附件区域 -->
			<div class="section">
				<div class="table-section">
					<div class="table-title">扫描附件</div>
					<table class="file-table">
						<thead>
							<tr>
								<th>文件名称</th>
								<th>上传人</th>
								<th>上传时间</th>
								<th>操作</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colspan="4" class="no-data">暂无扫描附件</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<!-- 上传模态框 -->
		<el-dialog :title="uploadDialogTitle" :visible.sync="uploadDialogVisible" width="500px"
			:before-close="handleUploadClose">

			<!-- 手工签名画板部分 -->
			<div v-if="currentUploadType === 'signature'" class="signature-pad-container">
				<canvas ref="signaturePad" width="450" height="250"
					style="border: 1px solid #ddd; background: #fff; width: 100%; cursor: crosshair;">
				</canvas>
				<div class="signature-actions">
					<el-button size="mini" @click="clearSignature" :disabled="loading">清空画板</el-button>
					<el-button size="mini" type="primary" @click="saveSignature" :loading="loading" :disabled="loading">
						{{ loading ? '保存中...' : '保存签名' }}
					</el-button>
				</div>
				<div class="signature-tips">
					<el-alert title="请在白色区域绘制您的签名" type="info" :closable="false" show-icon style="margin-top: 10px;"
						size="small">
					</el-alert>
				</div>
			</div>

			<!-- 图片上传 -->
			<div v-else class="image-upload-container">
				<el-upload class="upload-demo" drag :action="uploadUrl" :headers="uploadHeaders"
					:on-success="handleUploadSuccess" :before-upload="beforeUpload" :show-file-list="false">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					<div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过10MB</div>
				</el-upload>

				<!-- 图片预览 -->
				<div v-if="previewImage" class="image-preview">

					<div class="preview-actions">
						<el-button size="mini" @click="previewImage = ''">取消</el-button>
					</div>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handleUploadClose">取消</el-button>
				<el-button type="primary" @click="confirmUpload" :disabled="confirmDisabled">
					确认
				</el-button>
			</span>
		</el-dialog>

		<!-- 图片预览模态框 -->
		<el-dialog :visible.sync="imagePreviewVisible" width="60%" top="5vh" @close="imagePreviewVisible = false">
			<div class="image-preview-content">
				<div class="preview-header">
					<h3 class="preview-title">图片预览</h3>
					<div class="preview-info">
						<span class="info-item">图片类型: {{ currentPreviewType }}</span>
						<span class="info-item">上传时间: {{ currentPreviewTime }}</span>
						<span class="info-item">上传人: {{ currentPreviewUser }}</span>
					</div>
				</div>

				<div class="preview-image-container">

					<div v-if="imageSuccess" class="image-success">
						<img :src="currentPreviewImage" alt="" style="width: 100%;height: 100%;">
					</div>

					<div v-if="imageLoading" class="image-loading">
						<el-icon class="loading-icon"><el-icon-loading /></el-icon>
						<span>图片加载中...</span>
					</div>

					<div v-if="imageError" class="image-error">
						<el-icon class="error-icon"><el-icon-picture /></el-icon>
						<span>图片加载失败</span>
						<p class="error-tip">请检查图片链接是否正确</p>
					</div>



				</div>

				<div class="preview-actions">
					<el-button type="primary" size="mini" @click="downloadCurrentImage" :disabled="imageError">
						<el-icon><el-icon-download /></el-icon>
						下载图片
					</el-button>

					<el-button type="info" size="mini" @click="copyImageLink" :disabled="imageError">
						<el-icon><el-icon-document-copy /></el-icon>
						复制链接
					</el-button>

					<el-button type="warning" size="mini" @click="reuploadCurrentImage"
						v-if="currentPreviewType === '手工签名'">
						<el-icon><el-icon-refresh /></el-icon>
						重新上传
					</el-button>

					<el-button size="mini" @click="imagePreviewVisible = false">
						关闭
					</el-button>
				</div>

				<div class="preview-details" v-if="!imageError">
					<el-divider>图片信息</el-divider>
					<div class="detail-grid">
						<div class="detail-item">
							<span class="detail-label">图片尺寸:</span>
							<span class="detail-value">{{ imageDimensions.width }} × {{ imageDimensions.height }}
								像素</span>
						</div>
						<div class="detail-item">
							<span class="detail-label">文件大小:</span>
							<span class="detail-value">{{ formatFileSize(imageSize) }}</span>
						</div>
						<div class="detail-item">
							<span class="detail-label">图片格式:</span>
							<span class="detail-value">{{ imageFormat }}</span>
						</div>
						<div class="detail-item">
							<span class="detail-label">完整链接:</span>
							<span class="detail-value url-text">{{ currentPreviewImage }}</span>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>

		<!-- 新增科室对话框 -->
				<el-dialog :title="deptDialogTitle" :visible.sync="deptDialogVisible" width="500px"
					:before-close="handleDeptDialogClose" class="dept-form-dialog">
		
					<el-form :model="currentDept" :rules="deptFormRules" ref="deptForm" label-width="100px">
						<el-form-item label="科室名称" prop="deptName" class="required-field">
							<el-select 
								v-model="currentDept.deptName" 
								placeholder="请选择科室" 
								filterable 
								style="width: 100%"
								@change="handleDeptChange"
								:class="{ 'error-input': deptFieldErrors.deptName }"
								:disabled="isEditMode && editingDeptIndex !== -1">
								<el-option 
									v-for="item in deptOptions" 
									:key="item.id" 
									:label="item.label" 
									:value="item.label"
									:disabled="isDeptSelected(item.label)">
									<span>{{ item.label }}</span>
									<span style="float: right; color: #8492a6; font-size: 12px">
										{{ item.specialtyName }}
									</span>
								</el-option>
							</el-select>
							<div v-if="deptFieldErrors.deptName" class="field-error-message">
								{{ deptFieldErrors.deptName }}
							</div>
						</el-form-item>
		
						<el-form-item label="主要科室" prop="mainDep" class="required-field">
							<el-radio-group v-model="currentDept.mainDep" 
								:class="{ 'error-input': deptFieldErrors.mainDep }">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
							<div v-if="deptFieldErrors.mainDep" class="field-error-message">
								{{ deptFieldErrors.mainDep }}
							</div>
							<div class="field-tip" v-if="currentDept.mainDep === 1">
								<i class="el-icon-info"></i> 设置为主要科室后，其他科室将自动取消主要状态
							</div>
						</el-form-item>
					</el-form>
		
					<span slot="footer" class="dialog-footer">
						<el-button @click="handleDeptDialogClose">取消</el-button>
						<el-button type="primary" @click="validateAndSaveDept" :loading="deptLoading">
							{{ deptLoading ? '保存中...' : '保存' }}
						</el-button>
					</span>
				</el-dialog>

		<!-- 对话框底部 -->
		<!-- 修改底部按钮 -->
		<span slot="footer" class="dialog-footer">
			<el-button v-if="isEditMode" type="primary" @click="handleUpdate" size="mini" :loading="loading">
				保存
			</el-button>
			<el-button v-else type="primary" @click="handleSave" size="mini" :loading="loading">
				新建
			</el-button>
			<!-- <el-button type="primary" @click="handlePrint" size="mini">打印</el-button> -->
			<el-button @click="handleClose" size="medium">关闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		getLunar
	} from 'chinese-lunar-calendar'
	import {
		docclinic
	} from "@/api/cinic/cinic.js";
	import {
		findAttribute,
		getArea,
		getArea2,
		getArea3,
		addStaff
	} from "@/api/user.js";
	import {
		dict
	} from "@/api/staff/staff.js";
	// 导入修改相关API方法
	import {
		getStaff,
		updateStaff,
		builderImage
	} from "@/api/user.js";

	export default {
		name: 'WatchAccList',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			employeeId: {
				type: [Number, String],
				default: null
			},
			existingUsers: {
				type: Array,
				default: () => []
			},
			// 使用prop默认值而不是在data中重复声明
			clinicId: {
				type: [Number, String],
				default: 0
			},
			// 声明自定义事件
			emits: ['close', 'update-success', 'save'],
		},

		computed: {
			// 控制隶属科室按钮的禁用状态
			shouldDisableDeptButtons() {
				// 如果clinicId为0且未选择机构，禁用科室按钮
				if ((this.actualClinicId === 0 || this.actualClinicId === '0') &&
					!this.employeeData.organization) {
					return true;
				}
				return false;
			},
			uploadDialogTitle() {
				const titles = {
					signature: '上传手工签名',
					workPhoto: '上传员工证件照',
					qualification: '上传资格证电子图片',
					practice: '上传执业证电子图片'
				};
				return titles[this.currentUploadType] || '文件上传';
			},
			isEditingMode() {
				return this.isEditMode || this.editingDeptIndex !== -1;
			},
			// 添加计算属性来获取当前clinicId
			currentClinicId() {
				return this.clinicId;
			}
		},
		data() {
			return {
				// clinicId: this.clinicId, // 存储传入的clinicId
				// 添加一个内部变量来存储实际的clinicId
				actualClinicId: 0,
				clincOptions: [], // 机构选项
				deptList: [],
				deptOptions: [],
				deptOptionsBM: [],
				xlOptions: [],
				mjOptions: [],
				idType: [],
				deptLoading: false,
				socialSecurityStatusOptions: [{
						id: 0,
						label: '否'
					},
					{
						id: 1,
						label: '是'
					},
				],
				dialogVisible: false,

				// 添加编辑模式标识
				isEditMode: false,
				// 存储员工ID
				currentEmployeeId: null,
				// 添加加载状态
				loading: false,
				// 存储原始ID用于更新
				originalId: null,
				// 修复：移除未定义的 currentAddEmployeeData，使用正确的数据属性
				currentEmployeeData: null,
				// 移除这行：currentAddEmployeeData: null,
				// 使用正确的数据属性
				// 添加employeeData到data中，不再从props获取
				employeeData: {},
				currentPreviewImage: '',
				currentPreviewType: '',
				currentPreviewTime: '',
				currentPreviewUser: '',
				imageLoading: false,
				imageError: false,
				imageSuccess: false,
				imageDimensions: {
					width: 0,
					height: 0
				},
				imageSize: 0,
				imageFormat: '未知',
				onUpdateSuccess: {
					type: Function,
					default: () => {}
				},
				// 新增科室对话框相关
				deptDialogVisible: false,
				deptDialogTitle: '新增隶属科室',
				currentDept: {
					deptName: '',
					deptId: '',
					mainDep: '否'
				},
				editingDeptIndex: -1, // 当前编辑的科室索引
				currentClinicName: '',
				nextUserCode: '001',
				idNumberError: '', // 身份证错误提示
				// 表单选项数据
				addForm: {
					status: '1',
					userCode: "", //编码
					// fullNane: "001",//姓名
					fullName: "", //姓名
					idType: 1, //身份证类型id
					idTypeName: "", //身份证类型
					idNumber: "", //身份证号码
					sex: "", //性别
					dateOfEmp: "", //工作日期
					birthDate: "", //出生日期
					lunarBirthDate: "", //农历出生日期
					minZu: "", //民族
					nationality: 1, //国籍
					// nativePlace:"",//籍贯
					maritalStatus: "", //婚姻状况 1:未婚 2:已婚 3:离异
					politicalStatus: "", //政治面貌
					bloodType: "", //血型
					contactNumber: '', //联系电话
					contactAddress: '', //联系地址
					entryTime: '2025-01-18', //入职时间
					institutionId: "", //隶属机构

					contactAddress: '', //联系地址
					nativePlace: '', //户籍地址 = 籍贯
					standardCode: '', //医保编码
					standardName: '', //医保名称
					standardName: '', //医保名称
					//2
					deptList: [],
					deptOptions: [],
					deptOptionsBM: [],
					xlOptions: [],
					mjOptions: [],
					idType: [],
					educationalBackground: '', //学历
					major: '', //所学专业
					professionalTitle: '', //专业职称
					qualificationNumber: '', //资格证号
					practiceDate: '', //职业日期
					prescriptionRights: 0, //处方权
					chPrescriptionRights: 0, //中药处方权
					anesthesiaAuthorization: 0, //麻药权限
					surgicalPermission: 0, //手术权限
					spiritPermission: 0, //精神权限
					poisonPermission: 0, //毒药权限
					antiTumorPermission: 0, //抗肿瘤药物权限
					antibioticAuthorization: 0, // 抗生素等级
					roleId: [],
					//3
					signatureImage: '', //手工签名照片
					workIdPhoto: '', //工作证件照
					pcElectronicImage: '', //执业证电子图片
					qcElectronicImage: '' //资格证电子图片
				},

				positionOptions: [{
						id: 1,
						label: '项目经理'
					},
					{
						id: 2,
						label: '开发工程师'
					},
					{
						id: 3,
						label: '测试工程师'
					},
					{
						id: 4,
						label: 'UI设计师'
					}
				],
				educationOptions: [{
						id: 1,
						label: '高中'
					},
					{
						id: 2,
						label: '大专'
					},
					{
						id: 3,
						label: '本科'
					},
					{
						id: 4,
						label: '硕士'
					},
					{
						id: 5,
						label: '博士'
					}
				],
				majorOptions: [{
						id: 1,
						label: '计算机科学'
					},
					{
						id: 2,
						label: '软件工程'
					},
					{
						id: 3,
						label: '水利水电工程'
					},
					{
						id: 4,
						label: '电子信息工程'
					}
				],
				professionalTitleOptions: [{
						id: 1,
						label: '初级'
					},
					{
						id: 2,
						label: '中级'
					},
					{
						id: 3,
						label: '高级'
					},
					{
						id: 4,
						label: '专家'
					}
				],
				maritalStatusOptions: [],
				politicalStatusOptions: [{
						id: 0,
						label: '中共党员'
					},
					{
						id: 2,
						label: '中共预备党员'
					},
					{
						id: 3,
						label: '共青团员'
					},
					{
						id: 4,
						label: '民革党员'
					},
					{
						id: 5,
						label: '民盟盟员'
					},
					{
						id: 6,
						label: '民建会员'
					},
					{
						id: 7,
						label: '民进会员'
					},
					{
						id: 8,
						label: '农工党党员'
					},
					{
						id: 9,
						label: '致公党党员'
					},
					{
						id: 10,
						label: '九三学社社员'
					},
					{
						id: 11,
						label: '台盟盟员'
					},
					{
						id: 12,
						label: '无党派人士'
					},
					{
						id: 13,
						label: '群众'
					}
				],
				// 籍贯地址相关
				nativeOptions: [],
				// 添加标记防止重复初始化
				nativePlaceInitialized: false,
				nativePlaceModified: false,
				nationality: [], //国籍
				bloodOptions: [], // 血型
				marryiedOptions: [], // 婚姻状况
				professionalOptions: [], // 专业职称
				MZOptions: [],
				// 生日日期选择器选项
				birthdayPickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},

				// 权限相关 - 修复：移除selectedPermissions数组，直接绑定到employeeData
				permissions: {
					prescriptionRights: 0,
					chPrescriptionRights: 0,
					anesthesiaAuthorization: 0,
					surgicalPermission: 0,
					spiritPermission: 0,
					poisonPermission: 0,
					antiTumorPermission: 0
				},

				// 其他原有数据保持不变
				tableData: [],
				tableRows: [{
						name: "科室名称",
						prop: "deptName",
						type: ""
					},
					{
						name: "主要科室",
						prop: "mainDep",
						type: ""
					}
				],
				headerBtn: [{
						title: "新增",
						type: "success",
						icon: "el-icon-plus",
						action: 'add',
						disabled: false
					},
					{
						title: "编辑",
						type: "primary",
						icon: "el-icon-edit",
						action: 'edit',
						disabled: false
					},
					{
						title: "删除",
						type: "danger",
						icon: "el-icon-delete",
						action: 'delete',
						disabled: false
					}
				],
				selectedRow: null,
				editingRow: null,
				// 添加表单验证错误状态
				// 验证错误信息
				validationErrors: {
					// 原有验证错误
					fullName: false,
					idNumber: false,
					contactNumber: false,
					deptList: false,
					deptListMessage: '',
					deptTable: false,
					deptTableMessage: '',
					professionalTitle: false,
					organization: false
				},
				errorFields: [], // 存储有错误的字段名
				// 表单验证规则
				rules: {
					fullName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					idNumber: [{
							required: true,
							message: '请输入身份证号码',
							trigger: 'blur'
						},
						{
							pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
							message: '请输入正确的身份证号码',
							trigger: 'blur'
						}
					],
					contactNumber: [{
							required: true,
							message: '请输入联系电话',
							trigger: 'blur'
						},
						{
							pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur'
						}
					]
				},

				// 新增隶属科室模态框相关数据
				ksDialog: false,
				nameTitle: '新建员工',
				addBtn: true,
				addKsForm: {
					deptName: '',
					deptId: '',
					mainDep: '是',
				},
				formKsType: [{
						id: 0,
						label: '隶属科室：',
						spanRows: 24,
						type: 'select',
						modelValue: 'deptName',
						prefix: 'el-icon-require',
						im: true,
						placeholder: '',
						op: 'deptOption'
					},
					{
						id: 1,
						label: '主要科室：',
						spanRows: 24,
						type: 'select',
						modelValue: 'mainDep',
						prefix: 'el-icon-require',
						im: false,
						placeholder: '',
						op: 'statusOptions'
					},
				],
				// 上传相关数据
				uploadDialogVisible: false,
				currentUploadType: '',
				uploadedFile: null,
				signatureImage: null,
				previewImage: '',

				confirmDisabled: true, // 确认按钮默认禁用
				// 上传配置
				uploadUrl: 'http://192.168.101.20:9999/outpatient/builderImage',
				uploadHeaders: {
					'Authentication': localStorage.getItem('token')
				},
				uploadUser: 'admin',
				uploadTime: new Date().toLocaleString(),
				statusOptions: [{
					id: 1,
					label: '是',
					value: '重要科室'
				}, {
					id: 0,
					label: '否',
					value: '重要科室'
				}],
				deptOption: [],
				// 图片上传相关数据
				imageUploadList: [], // 图片上传列表
				imagePreviewVisible: false, // 图片预览模态框
				// currentPreviewImage: '', // 当前预览的图片
				uploadImageList: [], // 已上传的图片列表
				// 籍贯相关数据
				nativePlaceValue: [], // 级联选择器绑定的值
				nativePlaceOptions: [], // 级联选择器选项
				cascaderProps: {
					lazy: true,
					lazyLoad: this.loadAreaData,
					value: 'value',
					label: 'label',
					children: 'children',
					checkStrictly: true,
					// 添加emitPath: false以确保只返回最后一级的值
					emitPath: false
				},
				// 新增科室表单校验规则
				deptFormRules: {
					deptName: [
						{ required: true, message: '请选择科室名称', trigger: 'change' }
					],
					mainDep: [
						{ required: true, message: '请选择是否为主要科室', trigger: 'change' }
					]
				},
				// 科室字段错误信息
				deptFieldErrors: {
					deptName: '',
					mainDep: ''
				},
			};
		},
		watch: {
			'employeeData.nativePlace': {
				handler(newVal, oldVal) {
					// 只有当值真正变化且不是用户手动修改时才处理
					if (newVal !== oldVal && !this.nativePlaceModified) {
						console.log('employeeData.nativePlace变化，同步到级联选择器:', newVal);
						this.syncNativePlaceToCascader(newVal);
					}
				},
				immediate: true
			},
			// 修复clinicId监听
			clinicId: {
				immediate: true,
				handler(newVal, oldVal) {
					console.log('clinicId prop变化:', '新值:', newVal, '旧值:', oldVal, '类型:', typeof newVal);

					// 处理字符串和数字类型的比较
					const normalizedNewVal = newVal !== null && newVal !== undefined ? newVal.toString() : '0';
					const normalizedOldVal = oldVal !== null && oldVal !== undefined ? oldVal.toString() : '0';

					// 只有当值真正变化时才处理
					if (normalizedNewVal !== normalizedOldVal) {
						this.handleClinicIdChange(normalizedNewVal);
					}
				}
			},
			// 同步籍贯数据到级联选择器
			syncNativePlaceToCascader(nativePlace) {
				if (!nativePlace) {
					this.nativePlaceValue = [];
					return;
				}

				// 只有在查看模式或初始加载时才同步
				if (!this.isEditMode || !this.nativePlaceModified) {
					const placeArray = nativePlace.split('/');
					this.nativePlaceValue = placeArray;
				}
			},
			// 监听选择行变化，更新按钮状态
			selectedRow(newVal) {
				this.updateButtonStates();
			},
			// 监听编辑模式变化，更新按钮状态
			isEditMode(newVal) {
				this.updateButtonStates();
			},
			visible: {
				immediate: true,
				handler(newVal) {
					this.dialogVisible = newVal;
					if (newVal) {
						this.initData();
					}
				}
			},
			dialogVisible: {
				handler(newVal) {
					this.$emit('update:visible', newVal);
				}
			},
			employeeData: {
				immediate: true,
				handler(newData) {
					if (newData && newData.deptList) {
						this.tableData = newData.deptList;
					}
				}
			},
			'employeeData.idNumber': {
				handler(newVal) {
					if (newVal && newVal.length === 18) {
						this.calculateInfoFromIdNumber(newVal);
					}
				}
			}
		},
		mounted() {
			this.initData();
			this.initNativePlace(); // 初始化籍贯数据
		},
		methods: {
			// 初始化数据
			async initData() {
				console.log('初始化数据，当前clinicId prop:', this.clinicId, '类型:', typeof this.clinicId);
				this.employeeData.nationality = 1;
				this.employeeData.idType = 1;
				// 首先从本地存储获取实际的clinicId
				await this.getActualClinicIdFromStorage();

				// 根据实际的clinicId初始化
				this.handleClinicIdChange(this.actualClinicId);

				await this.calculateNextUserCode();
				await this.loadDictData();
				this.loadAreaProvince();

				// 根据clinicId决定是否加载科室选项
				if (this.actualClinicId && this.actualClinicId !== 0 && this.actualClinicId !== '0') {
					this.loadDeptOptionsByClinic(this.actualClinicId);
				}
			},
			// 从本地存储获取实际的clinicId
			async getActualClinicIdFromStorage() {
				try {
					const userInfo = JSON.parse(localStorage.getItem('userInfo'));
					if (userInfo && userInfo.clinicId) {
						this.actualClinicId = userInfo.clinicId;
						console.log('从本地存储获取clinicId:', this.actualClinicId);
					} else {
						// 如果没有从本地存储获取到，使用props传入的clinicId
						this.actualClinicId = this.clinicId !== null && this.clinicId !== undefined ? this.clinicId :
							0;
						console.log('使用props的clinicId:', this.actualClinicId);
					}
				} catch (error) {
					console.error('从本地存储获取clinicId失败:', error);
					this.actualClinicId = this.clinicId !== null && this.clinicId !== undefined ? this.clinicId : 0;
				}
			},

			// 处理clinicId变化的方法
			handleClinicIdChange(newClinicId) {
				console.log('处理clinicId变化:', newClinicId, '类型:', typeof newClinicId);

				// 统一处理字符串和数字的比较
				const clinicIdStr = newClinicId !== null && newClinicId !== undefined ? newClinicId.toString() : '0';

				if (clinicIdStr === '0') {
					console.log('clinicId为0，加载机构选项');
					// 如果clinicId为0，加载机构选项
					this.getInstitutionId();
				} else {
					console.log('clinicId不为0，设置当前诊所名称:', clinicIdStr);
					// 如果clinicId不为0，设置当前诊所名称
					this.getCurrentClinic(clinicIdStr);
				}
			},

			// 打开上传员工证件照对话框
			openUploadWorkPhoto() {
				this.currentUploadType = 'workPhoto';
				this.uploadDialogVisible = true;
				this.imageUploadList = []; // 清空上传列表
				this.uploadedFile = null;
				this.confirmDisabled = true;
			},

			// 根据诊所ID加载科室选项
			async loadDeptOptionsByClinic(clinicId) {
				try {
					const res = await findAttribute({
						clinicId: this.actualClinicId
					});

					if (res.code === 200) {
						this.deptOptions = res.data.map(v => ({
							id: v.id,
							label: v.deptName,
							value: v.deptName,
							specialtyName: v.specialtyName,
							remark: v.remark
						}));
						console.log('根据诊所加载科室选项:', this.deptOptions);
					}
				} catch (error) {
					console.error('根据诊所加载科室失败:', error);
				}
			},
			// 聚焦到错误字段
			focusErrorField(fieldName) {
				this.$nextTick(() => {
					const input = document.querySelector(`[data-field="${fieldName}"] input`);
					if (input) {
						input.focus();
					}
				});
			},
			// 新增：处理机构选择变化
			// 处理机构选择变化
			handleOrganizationChange(orgId) {
				const selectedOrg = this.clincOptions.find(item => item.id === orgId);
				if (selectedOrg) {
					this.employeeData.organization = selectedOrg.label;
					this.employeeData.clinicId = orgId;
					this.validationErrors.organization = false;

					// 根据选择的机构加载对应的科室
					this.loadDeptOptionsByClinic(orgId);
				}
			},

			// 获取当前诊所信息
			async getCurrentClinic(clinicId) {
				try {
					console.log('获取诊所信息，clinicId:', clinicId);

					// 统一处理字符串和数字
					const clinicIdStr = clinicId !== null && clinicId !== undefined ? clinicId.toString() : '0';

					if (clinicIdStr !== '0') {
						const userInfo = JSON.parse(localStorage.getItem('userInfo'));
						if (userInfo && userInfo.clinicName) {
							this.currentClinicName = userInfo.clinicName;
							this.employeeData.organization = userInfo.clinicName;
							this.employeeData.clinicId = clinicIdStr;
							console.log('使用用户信息中的诊所名称:', this.currentClinicName);
						} else {
							// 如果没有用户信息，尝试从API获取
							const res = await docclinic();
							if (res.code === 200 && res.data.length > 0) {
								// 根据clinicId查找对应的诊所
								const clinic = res.data.find(item => item.id.toString() === clinicIdStr) || res.data[
									0];
								this.currentClinicName = clinic.name;
								this.employeeData.organization = clinic.name;
								this.employeeData.clinicId = clinicIdStr;
								console.log('从API获取诊所名称:', this.currentClinicName);
							}
						}
					} else {
						// clinicId为0时的逻辑
						const userInfo = JSON.parse(localStorage.getItem('userInfo'));
						if (userInfo && userInfo.clinicName) {
							this.currentClinicName = userInfo.clinicName;
							this.employeeData.organization = userInfo.clinicName;
						} else {
							const res = await docclinic();
							if (res.code === 200 && res.data.length > 0) {
								this.currentClinicName = res.data[0].name;
								this.employeeData.organization = res.data[0].name;
							}
						}
					}
				} catch (error) {
					console.error('获取诊所信息失败:', error);
					this.currentClinicName = '默认机构';
					this.employeeData.organization = '默认机构';
				}
			},

			// 打开编辑模式 - 修复版本
			async openEditModel(employeeId) {
				console.log('打开编辑模式，员工ID:', employeeId);
			
				this.isEditMode = true;
				this.isAddMode = false;
				this.nameTitle = '修改员工';
				this.currentEmployeeId = employeeId;
			
				try {
					this.loading = true;
					const res = await getStaff({
						id: this.currentEmployeeId
					});
			
					if (res.code === 200) {
						console.log('获取员工数据成功:', res.data);
						
						// 处理员工数据
						const processedData = this.processEmployeeData(res.data);
						this.employeeData = JSON.parse(JSON.stringify(processedData));
			
						// 修复：确保工号正确显示
						if (this.employeeData.userCode) {
							this.nextUserCode = this.employeeData.userCode;
						}
			
						// 处理部门列表数据 - 确保mainDep字段正确转换和显示
						if (res.data.deptList && Array.isArray(res.data.deptList)) {
							this.tableData = this.normalizeDeptListData(res.data.deptList);
							console.log('处理后的科室数据:', this.tableData);
							
							// 确保表格正确显示mainDep字段
							this.$nextTick(() => {
								this.forceTableUpdate();
							});
						} else {
							this.tableData = [];
						}
			
						// 初始化籍贯数据
						await this.initNativePlace();
			
						// 打开对话框
						this.dialogVisible = true;
						this.$emit('update:visible', true);
						
						// 确保界面正确渲染
						this.$nextTick(() => {
							console.log('编辑模式初始化完成，当前tableData:', this.tableData);
						});
					}
				} catch (error) {
					console.error('获取员工数据失败:', error);
				} finally {
					this.loading = false;
				}
			},
			// 修改：标准化科室列表数据，确保mainDep字段正确转换为数字类型
			normalizeDeptListData(deptList) {
				if (!deptList || !Array.isArray(deptList)) {
					console.log('科室列表为空或不是数组');
					return [];
				}
			
				console.log('原始科室数据:', deptList);
			
				try {
					const normalizedList = deptList.map((dept, index) => {
						// 深拷贝科室对象
						const normalizedDept = { ...dept };
						
						// 处理mainDep字段：确保转换为数字类型 (0/1)
						normalizedDept.mainDep = this.normalizeMainDepValue(dept.mainDep);
						
						// 确保其他字段也存在
						if (!normalizedDept.deptId) {
							normalizedDept.deptId = dept.id || `dept_${index}`;
						}
						
						if (!normalizedDept.deptName) {
							normalizedDept.deptName = dept.name || '未知科室';
						}
						
						console.log(`科室 ${index} 处理结果:`, {
							原始: dept.mainDep,
							类型: typeof dept.mainDep,
							标准化: normalizedDept.mainDep
						});
						
						return normalizedDept;
					});
			
					console.log('标准化后的科室数据:', normalizedList);
					return normalizedList;
			
				} catch (error) {
					console.error('处理科室数据失败:', error);
					// 出错时返回默认数据
					return deptList.map((dept, index) => ({
						...dept,
						deptId: dept.deptId || dept.id || `dept_${index}`,
						deptName: dept.deptName || dept.name || '未知科室',
						mainDep: 0 // 出错时默认设为0
					}));
				}
			},
			
			// 修改：标准化mainDep值的辅助方法，确保返回数字类型
			normalizeMainDepValue(mainDepValue) {
				console.log('标准化mainDep值，输入:', mainDepValue, '类型:', typeof mainDepValue);
				
				if (mainDepValue === undefined || mainDepValue === null) {
					console.log('mainDep值为undefined或null，返回0');
					return 0;
				}
				
				// 处理字符串类型
				if (typeof mainDepValue === 'string') {
					const trimmedValue = mainDepValue.trim();
					if (trimmedValue === '是' || trimmedValue === '1' || trimmedValue === 'true' || trimmedValue === 'True') {
						console.log('字符串"是"转换为1');
						return 1;
					} else if (trimmedValue === '否' || trimmedValue === '0' || trimmedValue === 'false' || trimmedValue === 'False') {
						console.log('字符串"否"转换为0');
						return 0;
					} else {
						console.warn(`未知的mainDep字符串值: "${mainDepValue}"，默认为0`);
						return 0;
					}
				} 
				// 处理数字类型
				else if (typeof mainDepValue === 'number') {
					if (mainDepValue === 1) {
						console.log('数字1保持为1');
						return 1;
					} else if (mainDepValue === 0) {
						console.log('数字0保持为0');
						return 0;
					} else {
						console.warn(`mainDep数字值超出范围: ${mainDepValue}，调整为有效值`);
						return mainDepValue > 0 ? 1 : 0;
					}
				} 
				// 处理布尔类型
				else if (typeof mainDepValue === 'boolean') {
					console.log(`布尔值${mainDepValue}转换为${mainDepValue ? 1 : 0}`);
					return mainDepValue ? 1 : 0;
				} 
				// 其他类型
				else {
					console.warn(`未知的mainDep类型: ${typeof mainDepValue}，值:`, mainDepValue, '，默认为0');
					return 0;
				}
			},
			// 新增：强制表格更新方法
			forceTableUpdate() {
				// 通过重新赋值触发表格重新渲染
				this.tableData = [...this.tableData];
				console.log('表格数据强制更新完成');
			},

			// 处理图片上传前
			beforeImageUpload(file) {
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
				const isLt10M = file.size / 1024 / 1024 < 10;

				if (!isImage) {
					this.$message.error('只能上传图片格式文件!');
					return false;
				}
				if (!isLt10M) {
					this.$message.error('图片大小不能超过10MB!');
					return false;
				}

				// 添加到上传列表
				this.imageUploadList.push({
					name: file.name,
					url: URL.createObjectURL(file),
					file: file,
					status: 'ready',
					progress: 0
				});

				return false; // 手动上传
			},

			// 手动上传处理（用于签名画板）
			async handleManualUpload() {
				try {
					this.loading = true;

					const canvas = this.$refs.signaturePad;
					if (!canvas) {
						this.$message.warning('画板未初始化');
						return;
					}

					// 将canvas转换为blob
					const blob = await new Promise(resolve => {
						canvas.toBlob(resolve, 'image/png', 1.0);
					});

					// 创建FormData
					const formData = new FormData();
					formData.append('file', blob, 'signature.png');

					// 调用上传接口
					const res = await builderImage(formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
							'Authentication': localStorage.getItem('token')
						}
					});

					if (res.code === 200) {
						// 更新手工签名字段
						const imageUrl = `${res.data.host}${res.data.path}`;
						this.$set(this.employeeData, 'signatureImage', imageUrl);

						this.$message.success('手工签名上传成功');
						this.uploadDialogVisible = false;
					} else {
						this.$message.error(res.message || '签名上传失败');
					}
				} catch (error) {
					console.error('手动上传失败:', error);
					this.$message.error('上传过程中发生错误');
				} finally {
					this.loading = false;
				}
			},

			// 删除上传的图片
			handleRemoveImage(file, fileList) {
				this.imageUploadList = this.imageUploadList.filter(item => item.uid !== file.uid);

				// 如果没有图片了，禁用确认按钮
				if (this.imageUploadList.length === 0) {
					this.confirmDisabled = true;
				}
			},

			// 预览图片
			handlePictureCardPreview(file) {
				this.currentPreviewImage = file.url || file.finalUrl;
				this.imagePreviewVisible = true;
			},

			// 确认上传员工证件照
			confirmWorkPhotoUpload() {
				if (!this.uploadedFile) {
					this.$message.warning('请先上传图片');
					return;
				}

				// 更新员工数据中的证件照
				this.employeeData.workIdPhoto = this.uploadedFile;

				// 添加到已上传图片列表
				this.uploadImageList.push({
					url: this.uploadedFile,
					name: '员工证件照',
					uploadTime: new Date().toLocaleString()
				});

				this.$message.success('员工证件照上传成功');
				this.uploadDialogVisible = false;
				this.resetUploadState();
			},

			// 查看员工证件照
			viewWorkPhoto() {
				if (this.employeeData.workIdPhoto) {
					this.currentPreviewImage = this.employeeData.workIdPhoto;
					this.imagePreviewVisible = true;
				}
			},

			// 删除员工证件照
			removeWorkPhoto() {
				this.$confirm('确定要删除员工证件照吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.employeeData.workIdPhoto = '';
					this.$message.success('员工证件照已删除');
				});
			},

			// 初始化籍贯数据 - 修复版本
			async initNativePlace() {
				try {
					console.log('开始初始化籍贯数据，当前模式:', this.isEditMode ? '编辑' : '查看');

					// 加载省级数据
					const res = await getArea();
					if (res.code === 200) {
						this.nativePlaceOptions = res.data.map(item => ({
							value: item.areaName,
							label: item.areaName,
							leaf: false
						}));
						console.log('省级数据加载完成:', this.nativePlaceOptions);
					}

					// 如果编辑/查看模式且有籍贯数据，初始化籍贯值
					if ((this.isEditMode || !this.isEditMode) && this.employeeData.nativePlace) {
						console.log('有籍贯数据，开始初始化:', this.employeeData.nativePlace);
						await this.initNativePlaceValue();
					} else {
						console.log('没有籍贯数据或不是编辑/查看模式');
						this.nativePlaceValue = [];
					}
				} catch (error) {
					console.error('初始化籍贯数据失败:', error);
				}
			},

			// 初始化籍贯值（编辑/查看模式）- 修复版本
			async initNativePlaceValue() {
				if (!this.employeeData.nativePlace) {
					console.log('没有籍贯数据可初始化');
					this.nativePlaceValue = [];
					return;
				}

				try {
					console.log('开始初始化籍贯值:', this.employeeData.nativePlace);

					// 解析籍贯字符串（格式：省/市/区）
					const placeArray = this.employeeData.nativePlace.split('/');
					console.log('解析后的籍贯数组:', placeArray);

					// 设置级联选择器的值
					this.nativePlaceValue = placeArray;
					console.log('设置nativePlaceValue:', this.nativePlaceValue);

					// 标记为已初始化，避免被空选择覆盖
					this.nativePlaceInitialized = true;

					// 预加载级联路径（异步，不阻塞界面）
					this.$nextTick(() => {
						this.preloadCascaderPath(placeArray);
					});

				} catch (error) {
					console.error('初始化籍贯值失败:', error);
					this.nativePlaceValue = [];
				}
			},

			// 级联选择器变化处理 - 修复版本
			handleNativePlaceChange(value) {
				console.log('籍贯选择变化:', value);

				if (value && value.length > 0) {
					this.employeeData.nativePlace = value.join('/');
					console.log('设置employeeData.nativePlace:', this.employeeData.nativePlace);

					// 用户手动选择后，标记为已修改
					this.nativePlaceModified = true;
				} else {
					this.employeeData.nativePlace = '';
				}
			},

			// 预加载级联路径 - 修复版本
			async preloadCascaderPath(pathArray) {
				if (!pathArray || pathArray.length === 0) return;

				console.log('开始预加载级联路径:', pathArray);

				try {
					let currentOptions = this.nativePlaceOptions;

					for (let i = 0; i < pathArray.length; i++) {
						const currentValue = pathArray[i];
						console.log(`加载第${i + 1}级:`, currentValue);

						const foundOption = currentOptions.find(opt => opt.value === currentValue);

						if (foundOption) {
							console.log('找到选项:', foundOption);

							if (i < pathArray.length - 1 && !foundOption.children) {
								// 加载下一级数据
								console.log('需要加载下一级数据');
								await this.loadNextLevelData(foundOption, currentOptions);
							}

							if (foundOption.children) {
								currentOptions = foundOption.children;
							}
						} else {
							console.warn('未找到匹配的选项:', currentValue);
							break;
						}
					}
				} catch (error) {
					console.error('预加载级联路径失败:', error);
				}
			},

			// 加载下一级数据
			async loadNextLevelData(option, parentOptions) {
				try {
					let res;
					const level = parentOptions.indexOf(option) + 1;

					if (level === 1) {
						// 加载市级数据
						res = await getArea2({
							areaPName: option.value
						});
					} else if (level === 2) {
						// 加载区级数据
						const parentOption = parentOptions.find(opt => opt.children && opt.children.includes(option));
						res = await getArea3({
							areaPName: parentOption.value,
							areaCName: option.value
						});
					}

					if (res.code === 200) {
						option.children = res.data.map(item => ({
							value: item.areaName,
							label: item.areaName,
							leaf: level >= 3
						}));
						console.log(`加载第${level + 1}级数据成功:`, option.children);
					}
				} catch (error) {
					console.error('加载下一级数据失败:', error);
				}
			},


			// 重置上传状态
			resetUploadState() {
				this.uploadedFile = null;
				this.signatureImage = null;
				this.previewImage = '';
				this.confirmDisabled = true;

				// 清空画板
				this.clearSignature();
			},

			async openWatchModel(employeeId) {
				console.log('打开查看模式，员工ID:', employeeId);

				// 确保不是编辑模式
				this.isEditMode = false;
				this.isAddMode = false;
				this.nameTitle = '查看员工';
				this.currentEmployeeId = employeeId;

				try {
					this.loading = true;
					this.originalId = this.currentEmployeeId;

					// 调用接口获取员工数据
					const res = await getStaff({
						id: this.currentEmployeeId
					});
					console.log('查看模式API响应:', res);

					if (res && res.code === 200) {
						// 处理员工数据
						const processedData = this.processEmployeeData(res.data);
						this.employeeData = JSON.parse(JSON.stringify(processedData));

						// 处理部门列表数据
						if (res.data.deptList && Array.isArray(res.data.deptList)) {
							this.tableData = res.data.deptList.map(dept => ({
								...dept,
								mainDep: dept.mainDep === 1 ? '是' : '否'
							}));
						}

						// 关键修复：确保不会触发新建模式
						this.dialogVisible = true;
						this.$emit('update:visible', true);

						console.log('查看模式数据加载完成');
					} else {
						console.error('API返回错误:', res);
						this.$message.error(res?.message || '获取员工数据失败');
					}
				} catch (error) {
					console.error('获取员工数据失败:', error);
					this.$message.error('获取员工数据失败: ' + error.message);
				} finally {
					this.loading = false;
				}
			},

			// 处理员工数据，转换sex字段 - 修复方法
			processEmployeeData(data) {
				if (!data) {
					console.warn('processEmployeeData: 数据为空');
					return {};
				}
			
				console.log('原始员工数据:', data);
			
				try {
					// 深拷贝数据
					const processed = JSON.parse(JSON.stringify(data));
			
					// 处理deptList数据
					if (processed.deptList && Array.isArray(processed.deptList)) {
						processed.deptList = processed.deptList.map(dept => ({
							...dept,
							mainDep: this.normalizeMainDepValue(dept.mainDep)
						}));
						console.log('处理后的deptList:', processed.deptList);
					}
			
					// 转换sex字段：确保是字符串类型
					if (processed.sex !== undefined && processed.sex !== null) {
						console.log('原始sex值:', processed.sex, '类型:', typeof processed.sex);
			
						if (typeof processed.sex === 'number') {
							processed.sex = processed.sex.toString();
							console.log('数字转换sex:', processed.sex);
						} else if (typeof processed.sex === 'string') {
							// 已经是字符串，确保格式正确
							if (processed.sex === '1' || processed.sex === '2') {
								// 正确格式，不做处理
								console.log('sex已是正确字符串格式:', processed.sex);
							} else if (processed.sex === '男' || processed.sex.toLowerCase() === 'male') {
								processed.sex = '1';
								console.log('转换"男"为"1"');
							} else if (processed.sex === '女' || processed.sex.toLowerCase() === 'female') {
								processed.sex = '2';
								console.log('转换"女"为"2"');
							}
						}
					}
			
					console.log('处理后的员工数据:', processed);
					return processed;
			
				} catch (error) {
					console.error('处理员工数据失败:', error);
					return data; // 返回原始数据作为fallback
				}
			},

			// 身份证号输入完成处理 
			handleIdNumberBlur() {
				const idNumber = this.employeeData.idNumber;

				// 清空错误提示
				this.idNumberError = '';

				if (!idNumber) {
					this.idNumberError = '请输入身份证号码';
					return;
				}

				// 验证身份证格式
				const idCardPattern =
					/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
				if (!idCardPattern.test(idNumber)) {
					this.idNumberError = '请输入正确的18位身份证号码';
					return;
				}

				// 计算相关信息
				this.calculateInfoFromIdNumber(idNumber);
			},

			// 根据身份证号码计算相关信息 - 修复方法：不要强制覆盖sex
			calculateInfoFromIdNumber(idNumber) {
				if (idNumber && idNumber.length === 18) {
					try {
						// 提取出生日期
						const year = idNumber.substr(6, 4);
						const month = idNumber.substr(10, 2);
						const day = idNumber.substr(12, 2);

						// 设置出生日期
						this.employeeData.birthDate = `${year}-${month}-${day}`;

						// 计算农历生日
						try {
							const lunarInfo = getLunar(parseInt(year), parseInt(month), parseInt(day));
							this.employeeData.lunarBirthDate = lunarInfo.dateStr;
						} catch (error) {
							console.error('计算农历生日失败:', error);
							this.employeeData.lunarBirthDate = '计算失败';
						}

						// 判断性别
						const genderCode = parseInt(idNumber.substr(16, 1));
						this.employeeData.sex = genderCode % 2 === 1 ? '1' : '2';

						this.$message.success('身份证信息已自动填充');

					} catch (error) {
						console.error('处理身份证信息失败:', error);
						this.$message.error('处理身份证信息失败');
					}
				}
			},

			// 处理保存更新
			// 处理保存更新
			async handleUpdate() {
			  try {
			    // 表单验证
			    if (!this.validateForm()) {
			      return;
			    }
			
			    // 检查科室信息
			    if (!this.tableData || this.tableData.length === 0) {
			      this.$message.error('请至少添加一个隶属科室');
			      return;
			    }
			
			    this.loading = true;
			
			    // 准备提交数据 - 修复科室数据转换
			    const submitData = {
			      ...this.employeeData,
			      id: this.currentEmployeeId,
			      deptList: this.tableData.map(dept => ({
			        deptId: dept.deptId,
			        deptName: dept.deptName,
			        // 确保 mainDep 是数字类型
			        mainDep: dept.mainDep === 1 || dept.mainDep === '是' ? 1 : 0
			      }))
			    };
			
			    console.log('提交的数据:', submitData);
			
			    // 调用更新API
			    const res = await updateStaff(submitData);
			
			    if (res.code === 200) {
			      this.$message.success(res.message || '更新成功');
			      this.$emit('update-success');
			      this.handleClose();
			    } else {
			      this.$message.error(res.message || '更新失败');
			    }
			  } catch (error) {
			    console.error('更新失败:', error);
			    this.$message.error('更新过程中发生错误');
			  } finally {
			    this.loading = false;
			  }
			},

			// 处理新建保存
			async handleSave() {
			  try {
			    // 先进行表单验证
			    if (!this.validateForm()) {
			      this.showValidationErrors();
			      return;
			    }
			
			    this.loading = true;
			
			    // 准备提交数据
			    const submitData = {
			      ...this.employeeData,
			      id: null,
			      deptList: this.tableData.map(dept => ({
			        deptId: dept.deptId,
			        deptName: dept.deptName,
			        // 确保 mainDep 是数字类型
			        mainDep: dept.mainDep === 1 || dept.mainDep === '是' ? 1 : 0
			      }))
			    };
			
			    console.log('新建提交的数据:', submitData);
			
			    // 调用新建API
			    const res = await addStaff(submitData);
			
			    if (res.code === 200) {
			      this.$message.success(res.message || '新建成功');
			      this.$emit('update-success', submitData);
			      this.handleClose();
			    } else {
			      this.$message.error(res.message || '新建失败');
			      this.handleApiError(res);
			    }
			  } catch (error) {
			    console.error('新建失败:', error);
			    this.$message.error('新建过程中发生错误: ' + error.message);
			  } finally {
			    this.loading = false;
			  }
			},

			// 显示验证错误提示
			showValidationErrors() {
				const errorMessages = {
					fullName: '请输入姓名',
					idNumber: '请输入正确的身份证号码',
					contactNumber: '请输入正确的联系电话',
					deptList: '请至少添加一个隶属科室',
					professionalTitle: '请选择专业职称',
					organization: '请选择机构'
				};

				const firstError = this.errorFields[0];
				if (firstError && errorMessages[firstError]) {
					this.$message.error(errorMessages[firstError]);
				}
			},

			// 处理API返回的错误
			handleApiError(res) {
				// 根据API返回的错误信息设置对应的字段错误
				if (res.message && res.message.includes('姓名')) {
					this.validationErrors.fullName = true;
					this.scrollToFirstError('fullName');
				}
				// 可以根据实际API错误信息添加更多处理逻辑
			},

			// 计算下一个工号（修复版本）
			async calculateNextUserCode() {
				try {
					// 调用API获取最大的工号
					const res = await getMaxUserCode({
						clinicId: this.clinicId
					});
					if (res.code === 200 && res.data) {
						const maxCode = parseInt(res.data.maxCode || '0');
						this.nextUserCode = (maxCode + 1).toString().padStart(3, '0');
					} else {
						// 备用方案：从现有用户中计算
						if (this.existingUsers && this.existingUsers.length > 0) {
							const maxCode = Math.max(...this.existingUsers.map(user => {
								const code = parseInt(user.userCode || '0');
								return isNaN(code) ? 0 : code;
							}));
							this.nextUserCode = (maxCode + 1).toString().padStart(3, '0');
						} else {
							this.nextUserCode = '001';
						}
					}
				} catch (error) {
					console.error('计算工号失败:', error);
					this.nextUserCode = '001';
				}
			},

			// 打开上传对话框
			openUploadDialog(type) {
				this.currentUploadType = type;
				this.uploadDialogVisible = true;
				this.uploadedFile = null;
				this.signatureImage = null;
				this.previewImage = '';
				this.confirmDisabled = true;

				this.$nextTick(() => {
					if (type === 'signature') {
						this.initSignaturePad();
					}
				});
			},

			// 初始化签名画板
			initSignaturePad() {
				const canvas = this.$refs.signaturePad;
				if (!canvas) {
					console.error('Canvas元素未找到');
					return;
				}

				const ctx = canvas.getContext('2d');
				if (!ctx) {
					console.error('无法获取Canvas上下文');
					return;
				}

				let isDrawing = false;
				let lastX = 0;
				let lastY = 0;

				// 设置画板样式
				ctx.strokeStyle = '#000000';
				ctx.lineWidth = 2;
				ctx.lineCap = 'round';
				ctx.lineJoin = 'round';

				// 清除画布并设置白色背景
				ctx.fillStyle = '#FFFFFF';
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				// 鼠标事件处理函数
				const startDrawing = (e) => {
					isDrawing = true;
					[lastX, lastY] = this.getMousePos(canvas, e);
					ctx.beginPath();
					ctx.moveTo(lastX, lastY);
				};

				const draw = (e) => {
					if (!isDrawing) return;

					const [currentX, currentY] = this.getMousePos(canvas, e);

					ctx.lineTo(currentX, currentY);
					ctx.stroke();

					[lastX, lastY] = [currentX, currentY];
				};

				const stopDrawing = () => {
					if (!isDrawing) return;
					isDrawing = false;
					ctx.closePath();
				};

				// 获取鼠标位置
				this.getMousePos = (canvas, evt) => {
					const rect = canvas.getBoundingClientRect();
					return [
						evt.clientX - rect.left,
						evt.clientY - rect.top
					];
				};

				// 移除旧的事件监听器
				canvas.removeEventListener('mousedown', startDrawing);
				canvas.removeEventListener('mousemove', draw);
				canvas.removeEventListener('mouseup', stopDrawing);
				canvas.removeEventListener('mouseout', stopDrawing);

				// 添加新的事件监听器
				canvas.addEventListener('mousedown', startDrawing);
				canvas.addEventListener('mousemove', draw);
				canvas.addEventListener('mouseup', stopDrawing);
				canvas.addEventListener('mouseout', stopDrawing);
			},

			// 清空签名
			clearSignature() {
				const canvas = this.$refs.signaturePad;
				if (!canvas) return;

				const ctx = canvas.getContext('2d');
				ctx.fillStyle = '#FFFFFF';
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				// 重置绘图样式
				ctx.strokeStyle = '#000000';
				ctx.lineWidth = 2;
				ctx.lineCap = 'round';
				ctx.lineJoin = 'round';

				this.$message.info('画板已清空');
			},

			// 保存签名 - 修复版本
			async saveSignature() {
				const canvas = this.$refs.signaturePad;
				if (!canvas) {
					this.$message.warning('画板未初始化');
					return;
				}

				try {
					// 检查画布是否有内容
					const ctx = canvas.getContext('2d');
					const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
					let isEmpty = true;

					for (let i = 0; i < imageData.data.length; i += 4) {
						if (imageData.data[i + 3] !== 0) { // 检查alpha通道
							isEmpty = false;
							break;
						}
					}

					if (isEmpty) {
						this.$message.warning('请先绘制签名');
						return;
					}

					this.loading = true;

					// 将canvas转换为blob
					const blob = await new Promise(resolve => {
						canvas.toBlob(resolve, 'image/png', 1.0);
					});

					// 创建FormData
					const formData = new FormData();
					formData.append('file', blob, 'signature.png');

					// 调用上传接口
					const res = await builderImage(formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
							'Authentication': localStorage.getItem('token')
						}
					});

					console.log('上传接口响应:', res);

					if (res.code === 200) {
						console.log('签名上传成功:', res.data);

						// 修复URL拼接 - 使用统一的方法处理URL
						let imageUrl = 'http://' + res.data;

						console.log('生成的签名URL:', imageUrl);

						// 更新员工数据中的签名图片
						this.employeeData.signatureImage = imageUrl;

						// 关闭上传对话框
						this.uploadDialogVisible = false;

						this.$message.success('签名保存成功');

						// 重置上传状态
						this.resetUploadState();
					} else {
						console.error('上传失败:', res);
						this.$message.error(res.message || '签名上传失败');
					}
				} catch (error) {
					console.error('签名保存过程中发生错误:', error);
					this.$message.error('签名保存失败: ' + (error.message || '未知错误'));
				} finally {
					this.loading = false;
				}
			},

			// Base64转Blob
			dataURLToBlob(dataURL) {
				return new Promise((resolve, reject) => {
					try {
						const arr = dataURL.split(',');
						if (arr.length < 2) {
							reject(new Error('无效的base64数据'));
							return;
						}

						const mimeMatch = arr[0].match(/:(.*?);/);
						if (!mimeMatch) {
							reject(new Error('无法识别图片格式'));
							return;
						}

						const mime = mimeMatch[1];
						const bstr = atob(arr[1]);
						let n = bstr.length;
						const u8arr = new Uint8Array(n);

						while (n--) {
							u8arr[n] = bstr.charCodeAt(n);
						}

						resolve(new Blob([u8arr], {
							type: mime
						}));
					} catch (error) {
						reject(error);
					}
				});
			},

			// 确认上传 - 修复版本
			confirmUpload() {
				if (!this.uploadedFile) {
					this.$message.warning('请先上传文件或保存签名');
					return;
				}

				const fieldMap = {
					signature: 'signatureImage',
					workPhoto: 'workIdPhoto',
					qualification: 'qcElectronicImage',
					practice: 'pcElectronicImage'
				};

				const fieldName = fieldMap[this.currentUploadType];
				if (fieldName) {
					// 修复：确保uploadedFile是正确格式的URL
					let fileUrl = this.uploadedFile;

					// 如果uploadedFile是对象而不是字符串，需要处理
					if (typeof fileUrl === 'object' && fileUrl.url) {
						fileUrl = fileUrl.url;
					}

					// 检查URL格式，如果不是完整URL，可能需要添加基础URL
					if (typeof fileUrl === 'string' && !fileUrl.startsWith('http')) {
						fileUrl = this.getBaseUrl() + (fileUrl.startsWith('/') ? fileUrl : '/' + fileUrl);
					}

					// 更新员工数据
					this.$set(this.employeeData, fieldName, fileUrl);

					// 根据不同类型显示成功消息
					const successMessages = {
						signature: '手工签名保存成功',
						workPhoto: '员工证件照保存成功',
						qualification: '资格证图片保存成功',
						practice: '执业证图片保存成功'
					};

					this.$message.success(successMessages[this.currentUploadType] || '文件保存成功');

					// 关闭对话框
					this.uploadDialogVisible = false;

					// 重置状态
					this.resetUploadState();
				}
			},

			// 重新上传签名
			reuploadSignature() {
				this.openUploadDialog('signature');
			},

			// 显示图片预览
			showImagePreview(imageUrl, type = '手工签名') {
				if (!imageUrl) {
					this.$message.warning('没有可预览的图片');
					return;
				}

				this.currentPreviewImage = imageUrl;
				this.currentPreviewType = type;
				this.currentPreviewTime = this.getCurrentTime();
				this.currentPreviewUser = this.getCurrentUser();
				this.imageLoading = false;
				this.imageError = false;
				this.imageSuccess = true;
				// 重置图片信息
				this.imageDimensions = {
					width: 0,
					height: 0
				};
				this.imageSize = 0;
				this.imageFormat = '未知';

				this.imagePreviewVisible = true;
			},

			// 图片加载完成
			handleImageLoad(event) {
				this.imageLoading = false;
				const img = event.target;
				this.imageDimensions = {
					width: img.naturalWidth,
					height: img.naturalHeight
				};

				// 尝试获取图片大小和格式
				this.getImageInfo(this.currentPreviewImage);
			},

			// 图片加载失败
			handleImageError() {
				this.imageLoading = false;
				this.imageError = true;
				this.$message.error('图片加载失败，请检查链接是否正确');
			},

			// 获取图片信息
			async getImageInfo(url) {
				try {
					// 如果是网络图片，尝试获取文件信息
					if (url.startsWith('http')) {
						const response = await fetch(url, {
							method: 'HEAD'
						});
						if (response.ok) {
							const contentLength = response.headers.get('content-length');
							if (contentLength) {
								this.imageSize = parseInt(contentLength);
							}

							const contentType = response.headers.get('content-type');
							if (contentType) {
								this.imageFormat = contentType.split('/').pop().toUpperCase();
							}
						}
					}
				} catch (error) {
					console.warn('获取图片信息失败:', error);
					// 从URL推断格式
					const extension = url.split('.').pop().toLowerCase();
					if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
						this.imageFormat = extension.toUpperCase();
					}
				}
			},

			// 下载当前图片
			downloadCurrentImage() {
				if (!this.currentPreviewImage || this.imageError) {
					this.$message.warning('无法下载图片');
					return;
				}

				try {
					const link = document.createElement('a');
					link.href = this.currentPreviewImage;
					link.download =
						`${this.currentPreviewType}_${this.getFormattedDate()}.${this.imageFormat.toLowerCase()}`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.$message.success('开始下载图片');
				} catch (error) {
					console.error('下载失败:', error);
					this.$message.error('下载失败');
				}
			},

			// 复制图片链接
			copyImageLink() {
				if (!this.currentPreviewImage) {
					this.$message.warning('没有可复制的链接');
					return;
				}

				navigator.clipboard.writeText(this.currentPreviewImage)
					.then(() => {
						this.$message.success('链接已复制到剪贴板');
					})
					.catch(() => {
						// 降级方案
						const textarea = document.createElement('textarea');
						textarea.value = this.currentPreviewImage;
						document.body.appendChild(textarea);
						textarea.select();
						document.execCommand('copy');
						document.body.removeChild(textarea);
						this.$message.success('链接已复制到剪贴板');
					});
			},

			// 重新上传当前图片
			reuploadCurrentImage() {
				this.imagePreviewVisible = false;

				const typeMap = {
					'手工签名': 'signature',
					'员工证件照': 'workPhoto',
					'资格证': 'qualification',
					'执业证': 'practice'
				};

				const uploadType = typeMap[this.currentPreviewType];
				if (uploadType) {
					this.openUploadDialog(uploadType);
				}
			},

			// 格式化文件大小
			formatFileSize(bytes) {
				if (!bytes || bytes === 0) return '未知';
				const sizes = ['Bytes', 'KB', 'MB', 'GB'];
				const i = Math.floor(Math.log(bytes) / Math.log(1024));
				return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
			},

			// 获取当前时间
			getCurrentTime() {
				return new Date().toLocaleString('zh-CN', {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
					hour: '2-digit',
					minute: '2-digit'
				});
			},

			// 获取当前用户
			getCurrentUser() {
				try {
					const userInfo = JSON.parse(localStorage.getItem('userInfo'));
					return userInfo?.username || userInfo?.name || '当前用户';
				} catch {
					return '当前用户';
				}
			},

			// 获取格式化日期
			getFormattedDate() {
				const now = new Date();
				return `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}`;
			},

			// 删除文件
			removeFile(type) {
				const fieldMap = {
					signature: 'signatureImage',
					workPhoto: 'workIdPhoto',
					qualification: 'qcElectronicImage',
					practice: 'pcElectronicImage'
				};

				const fieldName = fieldMap[type];
				if (fieldName) {
					this.$confirm('确定要删除这个文件吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.employeeData[fieldName] = '';
						this.$message.success('删除成功');
					});
				}
			},

			// 关闭上传对话框
			handleUploadClose() {
				this.uploadDialogVisible = false;
				this.uploadedFile = null;
				this.signatureImage = null;
				this.previewImage = '';
				this.confirmDisabled = true;
			},


			// 上传前验证
			beforeUpload(file) {
				const isImage = file.type.startsWith('image/');
				const isLt10M = file.size / 1024 / 1024 < 10;

				if (!isImage) {
					this.$message.error('只能上传图片格式文件!');
					return false;
				}

				if (!isLt10M) {
					this.$message.error('图片大小不能超过10MB!');
					return false;
				}

				return true;
			},

			// 处理上传成功响应
			handleUploadSuccess(response, file, fileList) {
				console.log('文件上传成功响应:', response);

				if (response.code === 200) {
					// 根据当前上传类型更新对应的字段
					const fieldMap = {
						signature: 'signatureImage',
						workPhoto: 'workIdPhoto',
						qualification: 'qcElectronicImage',
						practice: 'pcElectronicImage'
					};

					const fieldName = fieldMap[this.currentUploadType];
					if (fieldName) {
						// 修复URL拼接逻辑 - 正确处理host和path
						let imageUrl = '';

						// 检查response.data是否已经是完整URL
						if (typeof response.data === 'string' && response.data.startsWith('http')) {
							// 如果已经是完整URL，直接使用
							imageUrl = response.data;
						} else if (response.data && response.data.host && response.data.path) {
							// 如果包含host和path字段，正确拼接
							const host = response.data.host;
							const path = response.data.path;

							// 确保host不以斜杠结尾，path不以斜杠开头
							const formattedHost = host.endsWith('/') ? host.slice(0, -1) : host;
							const formattedPath = path.startsWith('/') ? path : '/' + path;

							imageUrl = formattedHost + formattedPath;
						} else if (response.data && typeof response.data === 'string') {
							// 如果只有路径，可能需要添加基础URL
							imageUrl = this.getBaseUrl() + response.data;
						} else {
							console.error('无法解析的响应格式:', response.data);
							this.$message.error('上传成功但无法解析文件地址');
							return;
						}

						console.log('生成的图片URL:', imageUrl);

						// 更新employeeData对应的字段
						this.$set(this.employeeData, fieldName, imageUrl);

						// 根据不同类型显示成功消息
						const successMessages = {
							signature: '手工签名上传成功',
							workPhoto: '员工证件照上传成功',
							qualification: '资格证图片上传成功',
							practice: '执业证图片上传成功'
						};

						this.$message.success(successMessages[this.currentUploadType] || '文件上传成功');

						// 关闭上传对话框
						this.uploadDialogVisible = false;

						// 重置上传状态
						this.resetUploadState();
					}
				} else {
					this.$message.error(response.message || '文件上传失败');
				}
			},

			// 获取基础URL
			getBaseUrl() {
				// 根据你的实际配置返回正确的基础URL
				// 这里可以根据环境变量或配置返回不同的基础URL
				return window.location.origin; // 或者返回你的静态资源服务器地址
			},

			async uploadSignatureImage() {
				try {
					// 将base64转换为blob
					const response = await fetch(this.signatureImage);
					const blob = await response.blob();
					const file = new File([blob], 'signature.png', {
						type: 'image/png'
					});

					const formData = new FormData();
					formData.append('file', file);

					const res = await axios.post(this.uploadUrl, formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
							'Authentication': localStorage.getItem('token')
						}
					});

					if (res.code === 200) {
						this.uploadedFile = res.data;
						this.assignUploadedFile();
						this.uploadDialogVisible = false;
						this.$message.success('签名上传成功');
					}
				} catch (error) {
					console.error('签名上传失败:', error);
					this.$message.error('签名上传失败');
				}
			},

			assignUploadedFile() {
				const fieldMap = {
					signature: 'signatureImage',
					workPhoto: 'workIdPhoto',
					qualification: 'qcElectronicImage',
					practice: 'pcElectronicImage'
				};

				if (fieldMap[this.currentUploadType]) {
					this.employeeData[fieldMap[this.currentUploadType]] = this.uploadedFile;
					this.$emit('update:employeeData', this.employeeData);
				}
			},

			getFileName(url) {
				if (!url) return '';
				return url.split('/').pop() || '已上传文件';
			},

			// 保存员工信息
			async saveEmployee() {
				try {
					// 验证表单
					await this.$refs.addForm.validate();

					// 检查是否有主要科室
					const hasMainDept = this.addForm.deptList.some(dept => dept.mainDep === '是');
					if (!hasMainDept) {
						this.$message.error('必须设置一个主要科室');
						return;
					}

					// 准备数据
					const submitData = this.formatSubmitData();

					// 触发保存事件
					this.$emit('save', submitData);

				} catch (error) {
					console.error('表单验证失败:', error);
				}
			},

			// 格式化提交数据
			formatSubmitData() {
				return {
					...this.addForm,
					deptList: this.addForm.deptList.map(dept => ({
						deptName: dept.deptName,
						deptId: dept.deptId,
						mainDep: dept.mainDep
					}))
				};
			},

			// 加载字典数据
			async loadDictData() {
				try {
					const res = await dict();
					if (res.code === 200) {
						// 设置本地存储
						localStorage.setItem('dict', JSON.stringify(res.data));
						//  证件类型
						this.idType = res.data.certypeEntities.map(v => {
							return {
								label: v.name,
								...v
							}
						});
						//  民族
						this.MZOptions = res.data.natyEntities.map(v => {
							return {
								label: v.name,
								...v
							}
						})
						//  专业职称
						this.professionalOptions = res.data.profttlEntities.map(v => {
							return {
								label: v.name,
								...v
							}
						})
						// 所学专业
						this.mjOptions = res.data.profttlEntities.map(v => {
							return {
								label: v.name,
								...v
							}
						})
						// 学历
						this.xlOptions = res.data.edulBacdEntities.map(v => {
							return {
								label: v.name,
								...v
							}
						})
						// 婚姻状况选项
						this.marryiedOptions = res.data.mrgStateEntities.map(v => {
							return {
								label: v.name,
								...v
							}
						})
						// 国籍
						this.nationality = res.data.country.map(v => {
							return {
								label: v.name,
								...v
							}
						})
						//  血型
						this.bloodOptions = res.data.aboTypeEntities.map(v => {
							return {
								label: v.name,
								...v
							}
						})
						// 暂时过滤掉RH阴性和RH阳性的选项
						this.bloodOptions = this.bloodOptions.filter(item =>
							item.name !== 'RH阳性' && item.name !== 'RH阴性'
						);
					}
				} catch (error) {
					console.error('获取字典数据失败:', error);
					// 设置默认婚姻状况选项
					this.maritalStatusOptions = [{
							id: 1,
							label: '未婚'
						},
						{
							id: 2,
							label: '已婚'
						},
						{
							id: 3,
							label: '离异'
						},
						{
							id: 4,
							label: '丧偶'
						}
					];
				}
			},



			// 权限变更处理
			handlePermissionChange(permissions) {
				const allPermissions = [
					'prescriptionRights', 'chPrescriptionRights', 'anesthesiaAuthorization',
					'surgicalPermission', 'spiritPermission', 'poisonPermission',
					'antiTumorPermission'
				];

				allPermissions.forEach(permission => {
					this.employeeData[permission] = permissions.includes(permission) ? 1 : 0;
				});
			},

			// 确保关闭时重置所有模式状态
			handleClose() {
				this.dialogVisible = false;
				this.isEditMode = false;
				this.isAddMode = false;
				this.$emit('close');
				this.$emit('update:visible', false);
			},

			// 重置验证错误状态
			resetValidationErrors() {
				Object.keys(this.validationErrors).forEach(key => {
					this.validationErrors[key] = false;
				});
				this.errorFields = [];
			},

			// 滚动到第一个错误字段
			scrollToFirstError(fieldName) {
				this.$nextTick(() => {
					const errorElement = document.querySelector(`[data-field="${fieldName}"]`);
					if (errorElement) {
						errorElement.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						});

						// 添加闪烁效果
						errorElement.classList.add('error-highlight');
						setTimeout(() => {
							errorElement.classList.remove('error-highlight');
						}, 2000);
					}
				});
			},

			// 增强的表单验证方法
			validateForm() {
				// 重置错误状态
				this.resetValidationErrors();

				let isValid = true;
				const errors = [];

				// 验证姓名
				if (!this.employeeData.fullName?.trim()) {
					this.validationErrors.fullName = true;
					errors.push('fullName');
					isValid = false;
				}

				// 验证身份证号码
				if (!this.employeeData.idNumber) {
					this.validationErrors.idNumber = true;
					errors.push('idNumber');
					isValid = false;
				} else {
					const idCardPattern =
						/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
					if (!idCardPattern.test(this.employeeData.idNumber)) {
						this.validationErrors.idNumber = true;
						errors.push('idNumber');
						isValid = false;
					}
				}

				// 验证联系电话
				if (!this.employeeData.contactNumber) {
					this.validationErrors.contactNumber = true;
					errors.push('contactNumber');
					isValid = false;
				} else {
					const phonePattern = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
					if (!phonePattern.test(this.employeeData.contactNumber)) {
						this.validationErrors.contactNumber = true;
						errors.push('contactNumber');
						isValid = false;
					}
				}

				// 验证专业职称（如果字段存在且必填）
				if (this.employeeData.professionalTitle !== undefined && !this.employeeData.professionalTitle) {
					this.validationErrors.professionalTitle = true;
					errors.push('professionalTitle');
					isValid = false;
				}

				// 验证隶属科室
				if (!this.tableData || this.tableData.length === 0) {
					this.validationErrors.deptList = true;
					errors.push('deptList');
					isValid = false;
				}

				// 如果clinicId为0，验证机构选择
				if (this.actualClinicId === 0 || this.actualClinicId === '0') {
					if (!this.employeeData.organization) {
						this.validationErrors.organization = true;
						errors.push('organization');
						isValid = false;
					}
				}

				this.errorFields = errors;

				// 如果有错误，滚动到第一个错误字段
				if (!isValid && errors.length > 0) {
					this.scrollToFirstError(errors[0]);
				}

				return isValid;
			},


			// 加载部门选项
			async loadDeptOptionsBM() {
				try {
					// 这里可以根据实际情况调用API获取部门数据
					this.deptOptionsBM = [{
							id: 1,
							label: '项目部'
						},
						{
							id: 2,
							label: '技术部'
						},
						{
							id: 3,
							label: '人事部'
						},
						{
							id: 4,
							label: '财务部'
						}
					];
				} catch (error) {
					console.error('获取部门选项失败:', error);
				}
			},

			// 加载省级数据
			async loadAreaProvince() {
				try {
					const res = await getArea();
					if (res.code === 200) {
						this.nativeOptions = res.data.map(item => ({
							value: item.areaName,
							label: item.areaName,
							leaf: false
						}));
					}
				} catch (error) {
					console.error('获取省份数据失败:', error);
				}
			},

			// 级联选择懒加载方法
			async loadAreaData(node, resolve) {
				try {
					const {
						level
					} = node;
					let data = [];

					if (level === 0) {
						// 已加载过省级数据，直接返回
						resolve(this.nativeOptions);
						return;
					}

					if (level === 1) {
						// 加载市级数据
						const res = await getArea2({
							areaLevel: 2,
							areaPName: node.value
						});
						if (res.code === 200) {
							data = res.data.map(item => ({
								value: item.areaName,
								label: item.areaName,
								leaf: level >= 2
							}));
						}
					} else if (level === 2) {
						// 加载区级数据
						const parent = node.parent;
						const res = await getArea3({
							areaLevel: 3,
							areaPName: parent.value,
							areaCName: node.value
						});
						if (res.code === 200) {
							data = res.data.map(item => ({
								value: item.areaName,
								label: item.areaName,
								leaf: true
							}));
						}
					}

					resolve(data);
				} catch (error) {
					console.error('加载地区数据失败:', error);
					resolve([]);
				}
			},

			// 格式化日期
			formatDate(date) {
				if (!date) return '';
				return typeof date === 'string' ? date : date.toString();
			},

			// 查看文件
			viewFile(fileName) {
				this.$message.info(`查看文件: ${fileName}`);
			},

			// 下载文件
			downloadFile(fileName) {
				this.$message.success(`开始下载: ${fileName}`);
			},

			// 打印档案
			handlePrint() {
				this.$message.info('打印员工档案');
			},

			// 隶属科室相关方法
			handleHeaderBtnClick(btn, index) {
				if (btn.disabled) return;

				switch (btn.action) {
					case 'add':
						this.openAddDeptDialog();
						break;
					case 'edit':
						if (this.selectedRow) {
							this.openEditDeptDialog();
						}
						break;
					case 'delete':
						if (this.selectedRow) {
							this.handleDeleteDept();
						}
						break;
				}
			},

			// 打开编辑科室对话框
			async openEditDeptDialog() {
				if (!this.selectedRow) {
					this.$message.warning('请先选择要编辑的科室');
					return;
				}
			
				this.deptDialogTitle = '编辑隶属科室';
				
				// 确保当前编辑的科室数据mainDep是数字类型
				const normalizedMainDep = this.normalizeMainDepValue(this.selectedRow.mainDep);
				
				this.currentDept = {
					...this.selectedRow,
					// 确保mainDep是数字类型 (0/1)
					mainDep: normalizedMainDep
				};
				
				this.editingDeptIndex = this.tableData.indexOf(this.selectedRow);
				
				// 加载科室选项
				await this.loadDeptOptions();
				
				// 确保对话框正确显示后再设置数据
				this.deptDialogVisible = true;
				
				// 使用$nextTick确保DOM更新完成
				this.$nextTick(() => {
					console.log('编辑科室对话框打开完成，当前数据:', this.currentDept);
					console.log('mainDep值:', this.currentDept.mainDep, '类型:', typeof this.currentDept.mainDep);
					
					// 强制更新表单（如果有需要）
					if (this.$refs.deptForm) {
						this.$refs.deptForm.clearValidate();
					}
				});
			},

			// 处理删除科室 - 修复3: 添加updateButtonStates方法
			handleDeleteDept() {
				if (!this.selectedRow) return;

				const row = this.selectedRow;
				const index = this.tableData.indexOf(row);

				if (row.mainDep === 1) {
					if (this.tableData.length === 1) {
						this.$message.error('必须保留一个主要科室');
						return;
					}

					this.$confirm('此科室为主要科室，删除后将自动设置其他科室为主要科室，确定删除吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.tableData.splice(index, 1);
						// 自动设置第一个科室为主要科室
						if (this.tableData.length > 0) {
							this.tableData[0].mainDep = 1;
						}
						this.selectedRow = null;
						this.updateButtonStates(); // 修复3: 调用方法
						this.$message.success('删除成功');
					});
				} else {
					this.$confirm('确定要删除此科室吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.tableData.splice(index, 1);
						this.selectedRow = null;
						this.updateButtonStates(); // 修复3: 调用方法
						this.$message.success('删除成功');
					});
				}
			},


			// 打开新增科室对话框
			async openAddDeptDialog() {
				this.deptDialogTitle = '新增隶属科室';
				this.currentDept = {
					deptName: '',
					deptId: '',
					mainDep: this.tableData.length === 0 ? '是' : '否' // 如果没有科室，默认设为主要
				};
				this.editingDeptIndex = -1;

				// 加载科室选项
				await this.loadDeptOptions();
				this.deptDialogVisible = true;
			},

			// 加载科室选项
			async loadDeptOptions() {
				try {
					const res = await findAttribute({
						clinicId: this.employeeData.clinicId || this.clinicId
					});

					if (res.code === 200) {
						this.deptOptions = res.data.map(v => ({
							id: v.id,
							label: v.deptName,
							value: v.deptName,
							specialtyName: v.specialtyName,
							remark: v.remark
						}));
					}
				} catch (error) {
					console.error('加载科室选项失败:', error);
					this.$message.error('加载科室选项失败');
				}
			},

			// 检查科室是否已被选择
			isDeptSelected(deptName) {
				return this.tableData.some(item =>
					item.deptName === deptName &&
					this.tableData.indexOf(item) !== this.editingDeptIndex
				);
			},

			// 科室选择变化处理
			handleDeptChange(selectedDeptName) {
				const selectedDept = this.deptOptions.find(item => item.label === selectedDeptName);
				if (selectedDept) {
					this.currentDept.deptId = selectedDept.id;
					this.currentDept.deptName = selectedDept.label;
				}
			},
			// 验证并保存科室
			async validateAndSaveDept() {
			  try {
			    // 重置字段错误
			    this.resetDeptFieldErrors();
			    
			    // 表单验证
			    let formValid = true;
			    
			    // 验证科室名称
			    if (!this.currentDept.deptName) {
			      this.deptFieldErrors.deptName = '请选择科室名称';
			      formValid = false;
			    }
			    
			    // 验证主要科室
			    if (this.currentDept.mainDep === null || this.currentDept.mainDep === undefined) {
			      this.deptFieldErrors.mainDep = '请选择是否为主要科室';
			      formValid = false;
			    }
			    
			    if (!formValid) {
			      this.scrollToFirstDeptError();
			      this.$message.error('请完善科室信息');
			      return;
			    }
			    
			    // 验证表格数据
			    if (!this.validateDeptTable()) {
			      this.scrollToDeptTable();
			      return;
			    }
			    
			    // 保存科室
			    await this.saveDept();
			    
			  } catch (error) {
			    console.error('保存科室失败:', error);
			    this.$message.error('保存科室失败');
			  }
			},
			// 验证科室表格数据
			validateDeptTable() {
				// 检查是否有重复的科室名称或ID
				const deptMap = new Map();
				let hasDuplicate = false;
				let duplicateDeptName = '';
				
				for (const dept of this.tableData) {
					const key = `${dept.deptName}-${dept.deptId}`;
					if (deptMap.has(key)) {
						hasDuplicate = true;
						duplicateDeptName = dept.deptName;
						break;
					}
					deptMap.set(key, dept);
				}
				
				// 如果是编辑模式，排除当前编辑的科室
				if (this.editingDeptIndex !== -1) {
					const editingDept = this.tableData[this.editingDeptIndex];
					const editingKey = `${editingDept.deptName}-${editingDept.deptId}`;
					deptMap.delete(editingKey);
				}
				
				// 检查新科室是否重复
				const newDeptKey = `${this.currentDept.deptName}-${this.currentDept.deptId}`;
				if (deptMap.has(newDeptKey)) {
					this.validationErrors.deptTable = true;
					this.validationErrors.deptTableMessage = `科室 "${this.currentDept.deptName}" 已存在，不能重复添加`;
					this.$message.error(this.validationErrors.deptTableMessage);
					return false;
				}
				
				// 检查主要科室数量
				const mainDeptCount = this.tableData.filter(dept => dept.mainDep === 1).length;
				let willHaveMainDept = mainDeptCount;
				
				// 计算保存后的主要科室数量
				if (this.editingDeptIndex !== -1) {
					// 编辑模式：减去原来的，加上新的
					const oldDept = this.tableData[this.editingDeptIndex];
					if (oldDept.mainDep === 1) willHaveMainDept--;
					if (this.currentDept.mainDep === 1) willHaveMainDept++;
				} else {
					// 新增模式：直接加上新的
					if (this.currentDept.mainDep === 1) willHaveMainDept++;
				}
				
				// 验证主要科室数量
				if (willHaveMainDept === 0) {
					this.validationErrors.deptTable = true;
					this.validationErrors.deptTableMessage = '必须至少有一个主要科室';
					this.$message.error(this.validationErrors.deptTableMessage);
					return false;
				}
				
				if (willHaveMainDept > 1) {
					this.validationErrors.deptTable = true;
					this.validationErrors.deptTableMessage = '只能有一个主要科室';
					this.$message.error(this.validationErrors.deptTableMessage);
					return false;
				}
				
				this.validationErrors.deptTable = false;
				this.validationErrors.deptTableMessage = '';
				return true;
			},
			
			// 重置科室字段错误
			resetDeptFieldErrors() {
				this.deptFieldErrors = {
					deptName: '',
					mainDep: ''
				};
			},
			
			// 滚动到第一个科室表单错误
			scrollToFirstDeptError() {
				this.$nextTick(() => {
					const errorFields = [];
					if (this.deptFieldErrors.deptName) errorFields.push('deptName');
					if (this.deptFieldErrors.mainDep) errorFields.push('mainDep');
					
					if (errorFields.length > 0) {
						const firstErrorField = errorFields[0];
						const errorElement = document.querySelector(`[data-field="${firstErrorField}"]`);
						if (errorElement) {
							errorElement.scrollIntoView({
								behavior: 'smooth',
								block: 'center'
							});
							
							// 添加高亮效果
							errorElement.classList.add('error-highlight');
							setTimeout(() => {
								errorElement.classList.remove('error-highlight');
							}, 2000);
						}
					}
				});
			},
			
			// 滚动到科室表格
			scrollToDeptTable() {
				this.$nextTick(() => {
					const deptSection = document.querySelector('[data-field="deptList"]');
					if (deptSection) {
						deptSection.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						});
						
						// 添加高亮效果
						deptSection.classList.add('error-highlight');
						setTimeout(() => {
							deptSection.classList.remove('error-highlight');
						}, 2000);
					}
				});
			},
			// 修改：保存科室信息，确保数据类型一致性
			saveDept() {
				if (!this.currentDept.deptName) {
					this.$message.warning('请选择科室');
					return;
				}
			
				// 确保mainDep是数字类型
				const mainDepValue = this.normalizeMainDepValue(this.currentDept.mainDep);
				
				console.log('保存科室，mainDep值:', mainDepValue, '类型:', typeof mainDepValue);
				
				const deptData = {
					...this.currentDept,
					mainDep: mainDepValue // 确保是数字类型
				};
			
				if (this.editingDeptIndex === -1) {
					// 新增模式
					const exists = this.tableData.some(item =>
						item.deptName === deptData.deptName
					);
					if (exists) {
						this.$message.error('该科室已存在');
						return;
					}
			
					// 如果设置为主要科室，取消其他科室的主要状态
					if (deptData.mainDep === 1) {
						this.tableData.forEach(item => {
							item.mainDep = 0; // 设置为数字0
						});
					}
			
					this.tableData.push(deptData);
				} else {
					// 编辑模式
					const oldData = this.tableData[this.editingDeptIndex];
					const oldMainDep = this.normalizeMainDepValue(oldData.mainDep);
			
					// 如果从非主要改为主要，取消其他科室的主要状态
					if (oldMainDep === 0 && deptData.mainDep === 1) {
						this.tableData.forEach(item => {
							item.mainDep = 0; // 设置为数字0
						});
					}
			
					this.tableData.splice(this.editingDeptIndex, 1, deptData);
				}
			
				// 更新到employeeData，确保数据类型一致
				this.employeeData.deptList = this.tableData.map(item => ({
					...item,
					mainDep: this.normalizeMainDepValue(item.mainDep) // 确保是数字类型
				}));
				
				this.deptDialogVisible = false;
				this.$message.success('科室保存成功');
			
				// 清空选择
				this.selectedRow = null;
				this.updateButtonStates();
				
				console.log('保存后的科室数据:', this.tableData);
			},

			// 编辑科室
			handleEdit() {
				if (!this.selectedRow) {
					this.$message.warning('请先选择要编辑的科室');
					return;
				}

				this.deptDialogTitle = '编辑隶属科室';
				this.currentDept = {
					...this.selectedRow
				};
				this.editingDeptIndex = this.tableData.indexOf(this.selectedRow);
				this.loadDeptOptions().then(() => {
					this.deptDialogVisible = true;
				});
			},

			updateButtonStates() {
				// 在新增/编辑模式下，禁用编辑和删除按钮（除非选择了行）
				this.headerBtn.forEach(btn => {
					if (btn.action !== 'add') {
						btn.disabled = !this.selectedRow;
					}
				});
			},

			// 删除科室
			handleDelete() {
				if (!this.selectedRow) {
					this.$message.warning('请先选择要删除的科室');
					return;
				}

				const row = this.selectedRow;
				const index = this.tableData.indexOf(row);

				if (row.mainDep === '是') {
					if (this.tableData.length === 1) {
						this.$message.error('必须保留一个主要科室');
						return;
					}

					this.$confirm('此科室为主要科室，删除后将自动设置其他科室为主要科室，确定删除吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.tableData.splice(index, 1);
						// 自动设置第一个科室为主要科室
						if (this.tableData.length > 0) {
							this.tableData[0].mainDep = '是';
						}
						this.selectedRow = null;
						this.$message.success('删除成功');
					});
				} else {
					this.$confirm('确定要删除此科室吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.tableData.splice(index, 1);
						this.selectedRow = null;
						this.$message.success('删除成功');
					});
				}
			},

			// 关闭科室对话框
			handleDeptDialogClose(done) {
				this.$confirm('确定关闭吗？未保存的内容将会丢失', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					done();
				}).catch(() => {});
			},

			handClick(i) {
				if (i === 0) {
					this.getKs(this.clinicId);
					this.ksDialog = true;
					this.nameTitle = '新建员工';
					this.addKsForm = {
						deptName: '',
						deptId: '',
						mainDep: this.tableData.length === 0 ? '是' : '否'
					};
					this.addBtn = true;
				}
			},


			// 处理行点击
			handleRowClick(row) {
				this.selectedRow = row;
				this.updateButtonStates(); // 修复3: 调用方法
			},

			tableRowClassName({
				row
			}) {
				return row === this.selectedRow ? 'selected-row' : '';
			},

			sksName(v) {
				if (v.value == '重要科室') {
					this.addKsForm.mainDep = v.label;
					this.addBtn = false;
				} else {
					this.addKsForm.deptId = v.id;
					this.addKsForm.deptName = v.label;
					this.addBtn = false;
				}
			},

			// 新增/编辑保存科室
			addNewKs() {
				const isDeptExist = this.tableData.some(item =>
					item.deptName === this.addKsForm.deptName ||
					item.deptId === this.addKsForm.deptId
				);

				if (this.nameTitle !== '编辑' && isDeptExist) {
					this.$message.error(this.addKsForm.deptName + '：已存在于表格列表之中，请添加新的科室');
					return;
				}

				this.loading = true;

				if (this.nameTitle === '编辑') {
					setTimeout(() => {
						if (this.editingRow) {
							Object.assign(this.editingRow, JSON.parse(JSON.stringify(this.addKsForm)));
							this.$message.success('修改成功！');
						} else {
							this.$message.error('编辑数据无效！');
						}

						this.loading = false;
						this.ksDialog = false;
						this.editingRow = null;
					}, 888);
				} else {
					const hasMainDept = this.tableData.some(item => item.mainDep === '是');

					if (this.addKsForm.mainDep === '是' && hasMainDept) {
						this.$message.error('主要科室只能有一个，请修改后再添加！');
						this.loading = false;
						return;
					}

					setTimeout(() => {
						if (this.addKsForm.mainDep === '是') {
							this.tableData.forEach(item => {
								item.mainDep = '否';
							});
						}

						this.tableData.push(JSON.parse(JSON.stringify(this.addKsForm)));
						this.loading = false;
						this.ksDialog = false;
						this.$message.success('添加成功！');
					}, 1500);
				}
			},

			// 获取隶属机构
			async getInstitutionId() {
				try {
					let res = await docclinic();
					if (res.code === 200) {
						this.clincOptions = res.data.map(v => {
							return {
								id: v.id,
								label: v.name,
								value: v.id,
								...v
							}
						});
						console.log('加载机构选项:', this.clincOptions);
					}
				} catch (error) {
					console.error('获取机构信息失败:', error);
					this.$message.error('获取机构信息失败');
				}
			},

			// 获取科室
			async getKs(clinicId) {
				try {
					let res = await findAttribute({
						clinicId: clinicId
					});
					this.deptOption = res.data.map(v => {
						return {
							id: v.id,
							label: v.deptName,
							value: v.deptName,
							specialtyName: v.specialtyName,
							remark: v.remark
						}
					});
				} catch (error) {
					console.error('获取科室信息失败:', error);
					this.$message.error('获取科室信息失败');
				}
			},

			// 关闭模态框
			handleAddClose(done) {
				done();
				this.addKsForm = {
					deptName: '',
					deptId: '',
					mainDep: '是'
				};
			}
		}
	};
</script>

<style lang="less" scoped>
	/* 错误样式 */
	.error-row {
		background-color: #fff5f5 !important;

		td {
			border-color: #f56c6c !important;
		}
	}

	.error-input {
		/deep/ .el-input__inner {
			border-color: #f56c6c !important;
			background-color: #fff5f5;
		}
	}

	.error-section {
		border: 1px solid #f56c6c;
		border-radius: 4px;
		padding: 8px;
	}

	.error-table {
		border-color: #f56c6c !important;

		/deep/ .el-table__body-wrapper {
			border-color: #f56c6c;
		}
	}

	.error-tip {
		color: #f56c6c;
		font-size: 12px;
		padding: 8px;
		background: #fff5f5;
		border-radius: 4px;
		margin-top: 8px;

		i {
			margin-right: 4px;
		}
	}

	/* 错误高亮动画 */
	@keyframes errorHighlight {
		0% {
			background-color: #fff5f5;
		}

		50% {
			background-color: #ffe6e6;
		}

		100% {
			background-color: #fff5f5;
		}
	}

	.error-highlight {
		animation: errorHighlight 0.5s ease-in-out 3;
	}

	/* 必填字段标识 */
	.required-field::before {
	    content: "*";
	    color: #f56c6c;
	    margin-right: 4px;
	    font-weight: bold;
	    font-size: 14px;
	}
	
	/* 高亮显示必填字段 */
	.required-field {
	    position: relative;
	    font-weight: 600;
	}
	
	/* 错误状态下的必填字段 */
	.error-row .required-field::before {
	    color: #f56c6c;
	    animation: pulse 1.5s infinite;
	}
	
	/* 脉冲动画效果 */
	@keyframes pulse {
	    0% {
	        opacity: 1;
	    }
	    50% {
	        opacity: 0.5;
	    }
	    100% {
	        opacity: 1;
	    }
	}
	
	/* 表格标签样式优化 */
	.info-table .label {
	    position: relative;
	    padding-left: 12px !important;
	}
	
	/* 响应式设计 */
	@media (max-width: 768px) {
	    .required-field::before {
	        margin-right: 2px;
	        font-size: 12px;
	    }
	}

	::v-deep .el-form-item__label {
		font-size: 12px;
		font-weight: bold;
	}

	::v-deep .el-dialog__header {
		display: flex;
		background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
		padding: 12px 20px;
	}

	::v-deep .el-dialog__title {
		color: #fff;
	}

	/deep/ .el-form-item--mini.el-form-item,
	.el-form-item--small.el-form-item {
		margin-bottom: 12px;
	}

	/deep/ .el-dialog__title {
		color: #fff;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
		background-color: brown;
	}

	/deep/ .el-dialog__body {
		padding: 0;
	}

	/deep/ .el-divider--horizontal {
		margin: 0;
	}

	/* 图片预览样式 */
	.image-preview-content {
		padding: 20px;

		.preview-header {
			margin-bottom: 20px;

			.preview-title {
				margin: 0 0 10px 0;
				color: #303133;
				font-size: 18px;
				font-weight: 600;
			}

			.preview-info {
				display: flex;
				flex-wrap: wrap;
				gap: 20px;
				color: #606266;
				font-size: 14px;

				.info-item {
					padding: 4px 8px;
					background: #f5f7fa;
					border-radius: 4px;
				}
			}
		}

		.preview-image-container {
			position: relative;
			min-height: 300px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 20px;
			border: 1px solid #e4e7ed;
			border-radius: 4px;
			background: #fafafa;

			.preview-image {
				max-width: 100%;
				max-height: 400px;
				object-fit: contain;
			}

			.image-loading,
			.image-error {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				color: #909399;

				.loading-icon,
				.error-icon {
					font-size: 48px;
					margin-bottom: 10px;
				}

				.error-tip {
					margin: 5px 0 0 0;
					font-size: 12px;
					color: #c0c4cc;
				}
			}
		}

		.preview-actions {
			display: flex;
			justify-content: center;
			gap: 10px;
			margin-bottom: 20px;

			.el-button {
				min-width: 100px;
			}
		}

		.preview-details {
			.detail-grid {
				display: grid;
				grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
				gap: 12px;

				.detail-item {
					display: flex;
					align-items: center;

					.detail-label {
						font-weight: 600;
						color: #606266;
						margin-right: 8px;
						min-width: 80px;
					}

					.detail-value {
						color: #303133;
						word-break: break-all;

						&.url-text {
							font-size: 12px;
							color: #409EFF;
							cursor: pointer;

							&:hover {
								text-decoration: underline;
							}
						}
					}
				}
			}
		}
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.image-preview-content {
			padding: 15px;

			.preview-header {
				.preview-info {
					flex-direction: column;
					gap: 8px;
				}
			}

			.preview-image-container {
				min-height: 200px;

				.preview-image {
					max-height: 300px;
				}
			}

			.preview-actions {
				flex-wrap: wrap;

				.el-button {
					flex: 1;
					min-width: auto;
				}
			}

			.preview-details {
				.detail-grid {
					grid-template-columns: 1fr;
				}
			}
		}
	}

	/* 签名缩略图样式 */
	.signature-thumbnail {
		width: 50px;
		height: 50px;
		object-fit: contain;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		cursor: pointer;
		background-color: #fff;
		transition: transform 0.3s ease;
	}

	.signature-thumbnail:hover {
		transform: scale(1.1);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	/* 缩略图容器 */
	.thumbnail-container {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.thumbnail-actions {
		display: flex;
		flex-direction: column;
		gap: 5px;
	}

	/* 上传占位符 */
	.upload-placeholder {
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #909399;
		font-size: 12px;
	}

	.watch-acc-dialog {
		.el-dialog__header {
			background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
			padding: 12px 20px;

			.el-dialog__title {
				color: white;
				font-size: 16px;
				font-weight: 600;
			}

			.el-dialog__headerbtn {
				top: 12px;

				.el-dialog__close {
					color: white;

					&:hover {
						color: #f0f0f0;
					}
				}
			}
		}

		.el-dialog__body {
			padding: 0;
		}
	}

	.dialog-content {
		padding: 20px;
		max-height: 70vh;
		overflow-y: auto;

		.section {
			margin-bottom: 20px;

			.section-header {
				margin-bottom: 10px;

				.section-title {
					font-size: 14px;
					font-weight: 600;
					color: #303133;
					padding-left: 8px;
					border-left: 3px solid #67c23a;
				}
			}

			.table-section {
				background: #f8f9fa;
				border-radius: 4px;
				overflow: hidden;

				.table-title {
					background: #e1f3d8;
					padding: 8px 12px;
					font-size: 13px;
					font-weight: 600;
					color: #67c23a;
					border-bottom: 1px solid #dcdfe6;
				}

				.permissions-container {
					padding: 15px;
					background: white;

					.permission-row {
						display: flex;
						flex-wrap: wrap;
						margin-bottom: 10px;
						align-items: center;

						.el-checkbox {
							margin-right: 20px;
							min-width: 120px;
						}
					}
				}

				.header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					background: #e1f3d8;
					padding: 4px 12px;
					color: #67c23a;

					.el-button {
						margin-left: 5px;
					}
				}

				.info-table {
					width: 100%;
					border-collapse: collapse;

					td {
						padding: 8px 12px;
						border: 1px solid #dcdfe6;
						font-size: 12px;

						&.label {
							background: #f5f7fa;
							color: #606266;
							font-weight: 500;
							width: 80px;
							text-align: right;
						}

						&.value {
							background: white;
							color: #303133;
							width: 120px;
						}
					}

					tr:hover td {
						background: #f0f9ff;
					}
				}

				.file-table {
					width: 100%;
					border-collapse: collapse;

					th,
					td {
						padding: 10px 12px;
						border: 1px solid #dcdfe6;
						font-size: 12px;
						text-align: center;
					}

					th {
						background: #e1f3d8;
						color: #67c23a;
						font-weight: 600;
					}

					td {
						background: white;
						color: #303133;
					}

					tr:hover {
						background: #f0f9ff;
					}

					.no-data {
						color: #909399;
						font-style: italic;
						text-align: center;
					}

					.action-buttons {
						display: flex;
						justify-content: center;
						gap: 8px;

						.el-button {
							padding: 4px 8px;
							min-height: auto;

							&:hover {
								color: #67c23a;
							}
						}
					}
				}
			}
		}
	}

	/* 签名画板容器 */
	.signature-pad-container {
		padding: 10px;

		canvas {
			border: 1px solid #dcdfe6;
			border-radius: 4px;
			background: white;
		}

		.signature-actions {
			margin-top: 15px;
			text-align: center;

			.el-button {
				margin: 0 10px;
			}
		}
	}

	/* 图片预览 */
	.image-preview {
		margin-top: 20px;
		padding: 15px;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		background: #fafafa;

		.preview-title {
			font-size: 14px;
			font-weight: 600;
			margin-bottom: 10px;
			color: #606266;
		}

		.preview-img {
			max-width: 200px;
			max-height: 150px;
			border: 1px solid #dcdfe6;
			border-radius: 4px;
			cursor: pointer;
			transition: transform 0.3s;

			&:hover {
				transform: scale(1.05);
			}
		}

		.preview-actions {
			margin-top: 10px;
		}
	}

	/* 缩略图容器 */
	.file-upload-cell {
		.thumbnail-container {
			display: flex;
			align-items: center;
			gap: 10px;

			.thumbnail {
				width: 60px;
				height: 40px;
				object-fit: cover;
				border: 1px solid #dcdfe6;
				border-radius: 4px;
				cursor: pointer;
				transition: transform 0.3s;

				&:hover {
					transform: scale(1.1);
				}
			}

			.thumbnail-actions {
				display: flex;
				flex-direction: column;
				gap: 5px;

				.el-button {
					padding: 2px 8px;
					height: auto;
				}
			}
		}

		.upload-placeholder {
			display: flex;
			align-items: center;
			justify-content: space-between;
			color: #909399;
		}
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.signature-pad-container {
			padding: 10px;

			canvas {
				height: 200px;
			}
		}

		.thumbnail-container {
			flex-direction: column;
			align-items: flex-start !important;

			.thumbnail-actions {
				flex-direction: row !important;
			}
		}
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
		padding: 10px 20px;
		border-top: 1px solid #dcdfe6;
	}

	// 表格选中行样式
	/deep/ .el-table .selected-row {
		background-color: #f0f9eb;
	}

	// 滚动条样式
	.dialog-content::-webkit-scrollbar {
		width: 6px;
	}

	.dialog-content::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	.dialog-content::-webkit-scrollbar-thumb {
		background: #c0c4cc;
		border-radius: 3px;
	}

	.dialog-content::-webkit-scrollbar-thumb:hover {
		background: #909399;
	}

	// 响应式设计
	@media (max-width: 768px) {
		.watch-acc-dialog {
			width: 95% !important;
			margin: 20px auto;
		}

		.dialog-content {
			padding: 10px;

			.info-table {
				font-size: 11px;

				td {
					padding: 6px 8px;

					&.label,
					&.value {
						width: auto;
					}
				}
			}

			.file-table {
				font-size: 11px;

				th,
				td {
					padding: 6px 8px;
				}
			}

			.permissions-container {
				.permission-row {
					flex-direction: column;

					.el-checkbox {
						margin-bottom: 8px;
					}
				}
			}
		}
	}

	.info-table {

		.el-input,
		.el-select,
		.el-date-editor,
		.el-cascader {
			width: 100%;
		}

		td {
			padding: 4px 6px !important;

			.label {
				padding: 4px 6px !important;
			}
		}
	}

	// 新增隶属科室模态框样式
	.tabsMain {

		/deep/ .el-form-item--mini.el-form-item,
		.el-form-item--small.el-form-item {
			margin-bottom: 12px;
		}

		/deep/ .el-form-item__label {
			display: flex;
			justify-content: right;
			font-size: 12px;
		}

		/deep/ .el-input--mini .el-input__inner {
			height: 26px;
			line-height: 26px;
		}
	}
</style>